import React, { useEffect, useRef, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { VscNewFile } from "react-icons/vsc";
import InvoiceService from "../../../../client/src/services/invoice-service";
import GlobalVariable from "../../../../client/src/services/globalVar";
// import { Tooltip } from "primereact/tooltip";
import {
  IcomoonReact,
  iconSet,
  MultiSelect,
  Toast,
  ToggleButton,
} from "../PrimeReact";
import { Controller, useForm } from "react-hook-form";
import { Button } from "primereact/button";
// import { ConfirmPopup } from "../PrimeReact";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Dialog } from "primereact/dialog";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { format } from "date-fns";
import { Tooltip, Tag, Input, Space, Alert, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import InvoicePayment from "./InvoicePayment";
import { Dropdown as Primedropdown } from "primereact/dropdown";
import { number } from "yup";
import NewItem from "../Items/NewItem";
import GV from "../../services/globalVar";
import * as yup from "yup";
import AddInvoiceLineItem from "./AddInvoiceLineItem";
const Invoice = () => {
  const controller = new AbortController();
  const is = new InvoiceService();
  const [showInfoForm, setShowInfoForm] = useState(false);
  const paymodal = useRef(null);
  const yourRef = useRef(null);
  const [payment, setPayment] = useState("");
  const [invoiceItems, setInvoiceItems] = useState([]); 
  const [items, setItems] = useState([]); 
  const [invoiceDateValue, setInvoiceDateValue] = useState(null);
  const [isNewvoice, setIsNewvoice] = useState(true);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const inputRef = useRef(null);
  const [first1, setFirst1] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [sortName, setSortName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [invoiceGridDatas, setInvoiceGridDatas] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [billToDropDown, setBillToDropDown] = useState([]);
  const [selectedBillToDropDown, setSelectedBillToDropDown] = useState([]);
  const [quantityValue, setQuantityValue] = useState();
  const [discountValue, setDiscountValue] = useState(0);
  const [netAmountValue, setNetAmountValue] = useState(0);
  const [discountedAmount, setDiscountedAmount] = useState("0.00");
  const [subTotal, setSubTotal] = useState(0);
  const [paymentDueDateCount, setPaymentDueDateCount] = useState(null);
  const [paymentDueFormat, setPaymentDueFormat] = useState();
  const [productDrop, setProductDrop] = useState([]);
  const [selectProductDrop, setSelectProductDrop] = useState([]);
  const [itemType, setItemType] = useState();
  const [productRate, setProductRate] = useState();
  const [isType, setIsType] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [invoiceNumberD, setInvoiceNumberD] = useState();
  const [shipCharge, setShipCharge] = useState(0);
  const [manualErr, setManualErr] = useState(false);
  const [isCustChoose, setIsCustChoose] = useState(true);
  const [tenantDetails, setTenantDetails] = useState({});
  const [tenantDetailsOrg, setTenantDetailsOrg] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [sgstTax, setSgstTax] = useState(0);
  const [sgstTaxIndijual, setSgstTaxIndijual] = useState(0);
  const [cgstTax, setCgstTax] = useState(0);
  const [cgstTaxIndijual, setCgstTaxIndijual] = useState(0);
  const [igstTax, setIgstTax] = useState(0);
  const [igstTaxIndijual, setIgstTaxIndijual] = useState(0);
  const [roundOff, setRoundOff] = useState(0);
  const [sgstTaxAmount, setSgstTaxAmount] = useState(0);
  const [cgstTaxAmount, setCgstTaxAmount] = useState(0);
  const [igstTaxAmount, setIgstTaxAmount] = useState(0);
  const [countryTaxDetails, setCountryTaxDetails] = useState({});
  const [isProcess, setIsProcess] = useState(false);
  const [isDiscountDisabled, setIsDiscountDisabled] = useState(true);
  const [docUrl, setDocUrl] = useState("");
  const [selectDate, setSelectDate] = useState([]);
  const [showDocument, setShowDocument] = useState(false);
  const basiccolumns = [];
  const [selectedColumns, setSelectedColumns] = useState(basiccolumns);
  const [isEditingTotal, setIsEditingTotal] = useState(false);
  const [editedTotal, setEditedTotal] = useState(netAmountValue);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [displaynewItem, setdisplaynewItem] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [taxPreference, setTaxPreference] = useState("");
  const [goodsOrServiceItems, setGoodsOrServiceItems] = useState([]);
  const [serviceItems, setServiceItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [secStocks, setSecStocks] = useState(0);
  const [unitLabel, setUnitLabel] = useState("");
  const [secUnitLabel, setSecUnitLabel] = useState("");
  const [shippingAddressOptions, setShippingAddressOptions] = useState([]);
  const [selectedShipmentTo, setSelectedShipmentTo] = useState(null);
  const [additionalInfo, setAdditionalInfo] = useState({});
  const [invoiceType, setInvoiceType] = useState("invoice");
  const [selectedRound, setSelectedRound] = useState(0);
  const [isAdditionalInfoSaved, setIsAdditionalInfoSaved] = useState(false);
  const [pendingSubmitData, setPendingSubmitData] = useState(null);
  const [isScroll, setIsScroll] = useState(false);
  const [isManual, setisManual] = useState(true);
const [numberType, setNumberType] = useState("auto");

  let schema = yup.object().shape({
    //basic
    type: yup.string().required("This field is required"),
    name: yup.string().required("This field is required"),
    unit: yup.string().required("This field is required"),
    stocks: yup.string(),
    code: yup.string().required("This field is required"),
    status: yup.string().required("This field is required"),
    //sales info
    salescheck: yup.boolean(),
    sellingprice: yup.string(),
    // siAccount: yup.string(),
    status: yup.string(),
    description: yup.string(),
    //cost info
    costcheck: yup.boolean(),
    costprice: yup.string(),
    // piAccount: yup.string(),
    description1: yup.string(),
    //tax
    taxpreference: yup.string(),
    cgst: yup.string().required("This field is required"),
    sgst: yup.string().required("This field is required"),
    igst: yup.string().required("This field is required"),
  });

  //   useEffect(() => {
  //   return () => {
  //     Object.values(is.controllers).forEach((c) => c.abort());
  //     is.controllers = {};
  //   };
  // }, []);

  const [termName, setTermName] = useState([
    { id: 1, count: 0, name: "Today", label: "today" },
    { id: 2, count: 7, name: "Net 7", label: "Net 7" },
    { id: 3, count: 15, name: "Net 15", label: "Net 15" },
    { id: 4, count: 30, name: "Net 30", label: "Net 30" },
    { id: 5, count: 45, name: "Net 45", label: "Net 45" },
    { id: 6, count: 60, name: "Net 60", label: "Net 60" },
    { id: 7, count: 75, name: "Net 75", label: "Net 75" },
    { id: 8, count: 90, name: "Net 90", label: "Net 90" },
  ]);
  const [frequencyType, setFrequencyType] = useState([
    { id: 1, name: "None", label: "None", value: "None" },
    { id: 2, name: "Weekly", label: "Weekly", value: "Weekly" },
    { id: 3, name: "Monthly", label: "Monthly", value: "Monthly" },
    { id: 4, name: "Yearly", label: "Yearly", value: "Yearly" },
  ]);
  const [selectedType, setSelectedType] = useState(frequencyType[0].value);
  const [selectedTerm, setSelectedTerm] = useState();
  const [editable, setEditable] = useState(false);
  const itemStatus = [
    { id: 1, label: "All", value: "ALL" },
    { id: 2, label: "Open", value: "OPEN" },
    { id: 3, label: "Partially Paid", value: "PARTIALLY PAID" },
    { id: 4, label: "Paid", value: "PAID" },
    { id: 5, label: "Draft", value: "DRAFT" },
    { id: 6, label: "Overdue", value: "OVERDUE" },
  ];
  const invoiceTypeList = [
    { id: 1, label: "All", value: "" },
    // { id: 2, label: "Proforma Invoice", value: "ProformaInvoice" },
    { id: 3, label: "Sales Invoice", value: "SalesInvoice" },
    { id: 4, label: "Export Invoice", value: "ExportInvoice" },
  ];
  const [filterGrid, setFilterGrid] = useState(itemStatus[0].value);
  const [invTypeFilterGrid, setInvTypeFilterGrid] = useState(
    invoiceTypeList[0].value
  );

  const toast = useRef(null);
  const defaultValues = {
    billto: "",
    invoicenumber: "",
    paymentduedate: "",
    ponumber: "",
    term: "",
    billfrom: "",
    billingType: "",
    frequency: "",
    selectdate: "",
    originatingFrom: "",
    destination: "",
    deliveryPoint: "",
    despatchDetails: "",
    portOfLoading: "",
    portOfDischarge: "",
    shipmentType: "",
    remark: "",
    // termdelivery: "",

    // ✅ Add this line
    shipmentto: null,
    grossWeight: "",
    netWeight: "",
    totalLiters: "",
    coo: "",
    contactName: "",
    contactPhone: "",
    contactEmail: "",
  };

  const {
    register,
    reset,
    control,
    getValues,
    setValue,
    formState: { errors },
    handleSubmit,
    clearErrors,
    watch,
  } = useForm({ mode: "onChange", defaultValues });

  const {
    register: modalRegister,
    handleSubmit: modalHandleSubmit,
    control: modalControl,
    watch: modalWatch,
    setValue: modalSetValue,
    getValues: modalGetValues,
    reset: modalReset,
    formState: { errors: modalErrors },
  } = useForm({
    mode: "onChange",
    defaultValues: {},
  });

  const {
    register: additionalRegister,
    handleSubmit: additionalHandleSubmit,
    setValue: additionalSetValue,
    formState: { errors: additionalErrors },
    reset: additionalReset,
  } = useForm({
    defaultValues: {
      grossWeight: "",
      netWeight: "",
      totalLiters: "",
      coo: "",
      contactName: "",
      contactPhone: "",
      contactEmail: "",
    },
  });

  const onAdditionalInfoSubmit = (infoData) => {
    setAdditionalInfo(infoData);
    setIsAdditionalInfoSaved(true);
    setShowInfoForm(false);

    if (pendingSubmitData) {
      const { data, status } = pendingSubmitData;
      onSubmit({ ...data, additionalInfo: infoData }, status);
      setPendingSubmitData(null);
    }
  };

  const [invoiceLines, setInvoiceLines] = useState([
    // {
    //   id: 1,
    //   productname: "",
    //   quantity: 0,
    //   rate: "",
    //   discount: 0,
    //   statetax: 0,
    //   centraltax: 0,
    //   intertax: 0,
    //   netamount: "",
    //   producttype: "",
    //   shippngcharge: "",
    // },
  ]);

  const clearFields = () => {
    setInvoiceLines([
      // {
      //   id: 1,
      //   productname: "",
      //   quantity: 0,
      //   rate: "",
      //   discount: 0,
      //   statetax: 0,
      //   centraltax: 0,
      //   intertax: 0,
      //   netamount: "",
      //   producttype: "",
      //   shippngcharge: "",
      // },
    ]);
  };

  const addNewLine = () => {
    setIsType(true);
    const invalidInvoiceLines = invoiceLines.filter(
      (line) =>
        line.productname === "" ||
        line.quantity === "" ||
        line.discount === "" ||
        line.tax === ""
    );
    if (invalidInvoiceLines.length > 0) {
      setManualErr("Unable to duplicate empty fields");
      return;
    } else {
      setManualErr("");
      const newId = invoiceLines[invoiceLines.length - 1].id + 1;
      const newLine = {
        id: newId,
        productname: "",
        quantity: "",
        rate: "",
        discount: "",
        statetax: "",
        centraltax: "",
        intertax: "",
        netamount: "",
        producttype: "",
      };

      setInvoiceLines((prevInvoiceLines) => [...prevInvoiceLines, newLine]);
    }
  };

  const addLine = () => {
    mReset();
    handleTypeChange("goods");
    setdisplaynewItem(true);
    setIsScroll(false)
  };

  const [lazyParams, setLazyParams] = useState({
    first: first1,
    rows: sizePerPage,
    page: page,
    sortField: sortName,
    sortOrder: sortOrder,
  });

  const invoiceGrid = (
    page,
    sizePerPage,
    searchVal,
    sortName,
    sortOrder,
    filterGrid
  ) => {
    setIsProcess(true);
    const data = {
      InputParams: {
        TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
        ContactID: 0,
        Status: filterGrid,
        InvType: invTypeFilterGrid,
      },
      ServerSearchables: {
        draw: 1,
        searchData: searchVal || "",
        orderByColumn: sortName,
        orderBy: sortOrder,
        currentPage: 0,
        pageSize: sizePerPage,
        pageNumber: page,
      },
    };
    is.GetSalesInvoiceListSearch(data).then((res) => {
      setIsProcess(false);
      setInvoiceGridDatas(res.data.data.salesInvoiceList);
      setTotalRecords(res.data.data.serverSearchables.recordsTotal);
    });
  };

  const GetSalesItemList = (signal) => {
    is.GetSalesItemList(GlobalVariable.userDet.tenantDetail.tenantID, signal).then(
      (res) => {
        if (res.data.statusCode === 200) {
          setProductDrop(res.data.data);
        }
      }
    );
  };

  const handleAddClick = (e) => {
    // e.preventDefault();
    setIsModalOpen(true);
    setdisplaynewItem(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const extendedProductDrop = [
    ...productDrop,
    { name: "+ Add New Item", code: "add-new" },
  ];

  const itemTemplate = (option) => {
    if (option.code === "add-new") {
      return (
        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            color: "#2e7d32",
            cursor: "pointer",
          }}
        >
          {" "}
          {option.name}{" "}
        </div>
      );
    }
    return <span>{option.name}</span>;
  };

  const handleItemAddSuccess = () => {
    GetSalesItemList();
    setIsModalOpen(false);
  };

  const handleSelectTaxPreference = (e) => {
    //    data.sgst
    setTaxPreference(e.target.value);
  };

  const checkValidation = (e) => {
    if (e.target.checked) {
      setValue("salescheck", true);
    } else {
      setValue("salescheck", false);
      clearErrors(["sellingprice", "siAccount", "description"]);
    }
    if (getValues("salescheck")) {
      schema = yup.object().shape({
        ...schema.fields,
        sellingprice: yup.string().required("This field is required"),
      });
    } else {
      schema = yup.object().shape({
        ...schema.fields,
        sellingprice: yup.string().notRequired(""),
        // siAccount: yup.string(),
        status: yup.string(),
        description: yup.string(),
      });
    }
  };

  const checkCostValidation = (e) => {
    setValue("costcheck", e.target.checked);
    if (e.target.checked) {
      setValue("costcheck", true);
    } else {
      setValue("costcheck", false);
      clearErrors(["costprice", "piAccount", "description1"]);
    }
    let copySchema = schema;
    if (getValues("costcheck")) {
      copySchema = yup.object().shape({
        ...schema.fields,
        costprice: yup.string().required("This field is required"),
      });
    } else {
      copySchema = yup.object().shape({
        ...schema.fields,
        costprice: yup.string().notRequired(""),
        description1: yup.string(),
      });
    }
    schema = copySchema;
  };

const GenerateConfigNumber = (type) => {
  const data = {
    TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
    ServiceName: type === "export" ? "exportinvoice" : "invoice",
     // auto / manual
  };

  console.log("API Request =>", data);

  is.GenerateConfigNumber(data).then((res) => {
    // Only update auto-generated values
    if (numberType === "auto") {
      setInvoiceNumberD(res.data.data);
    }
  });
};

useEffect(() => {
  if (invoiceType) {
    GenerateConfigNumber(invoiceType);
  }
}, [ invoiceType]);



useEffect(() => {
  if (numberType === "auto") {
    GenerateConfigNumber();
  }
}, [numberType]);


  const handleSelectProduct = (selectedProduct, index) => {
    const isIntraState = tenantDetails.state === selectedBillToDropDown.baState;
    setIsDiscountDisabled(false);
    setManualErr("");
    const updatedLines = invoiceLines.map((line, i) => {
      if (i === index) {
        return {
          id: Date.now(),
          productname: selectedItem,
          quantity: 1,
          boxes: 0,
          discount: 0,
          statetax: isIntraState ? selectedItem.localTaxRate : 0,
          centraltax: isIntraState ? selectedItem.centralTaxRate : 0,
          intertax: isIntraState ? 0 : selectedItem.interTaxRate,
          producttype: selectedItem.itemType,
          rate: selectedItem.siSellingPrice?.toFixed(2),
          netamount: selectedItem.siSellingPrice,
        };
      }
      return line;
    });

    handleTaxChangeWithoutIndex(updatedLines, index);
    handleTaxChange(updatedLines);
    setInvoiceLines(updatedLines);
    setIsType(true);
    setSelectProductDrop(selectedProduct);
    setItemType(selectedProduct);
    setProductRate(selectedProduct);
  };

  const onCustomPage1 = (event) => {
    setFirst1(event.first);
    const val = event.page + 1;
    const size = event.rows;
    setSizePerPage(size);
    setPage(val);
    invoiceGrid(val, size, searchVal, "", "", filterGrid);
  };

  const onSort = (event) => {
    setLazyParams(event);
  };

  const handleRowClick = (event) => {
    setRowData(event.data);
  };

  const createNewInvoice = () => {
    setIsNewvoice(!isNewvoice);
    setRowData("");
    setDiscountedAmount("0.00");
    setSelectedRound(0);
    setEditable(false);
  };

  const backToAllInvoice = () => {
    setIsType(false);
    setIsUpdate(false);
    reset(defaultValues);
    setInvoiceDate(new Date());
    clearFields();
    setIsNewvoice(!isNewvoice);
    setIsCustChoose(true);
    setNetAmountValue("");
    setInvoiceDateValue("");
    setPaymentDueDateCount("");
    setSelectProductDrop("");
    setItemType("");
    setProductRate("");
    setSubTotal(0);
    setDiscountValue(0);
    setSgstTax(0);
    setCgstTax(0);
    setIgstTax(0);
    setRoundOff(0);
    setNetAmountValue(0);
    setShipCharge(0);
    setCgstTaxAmount(0);
    setSgstTaxAmount(0);
    setIgstTaxAmount(0);
    setDiscountedAmount(0);
    setSelectedRound(0);
    setInvoiceType("invoice");
    setNumberType("auto");
    invoiceGrid(page, sizePerPage, searchVal, "", "", "");
    GenerateConfigNumber();
    setSelectedType(frequencyType[0].value);
setisManual(true);

  };

  const nameBodyTemplate = (rowData) => {
    return rowData.firstName + " " + rowData.lastName;
  };

  const dateBodyTemplate = (rowData) => {
    let formattedDate = "-";
    if (rowData.dueDate !== null) {
      const parsedDate = new Date(rowData.dueDate);
      if (!isNaN(parsedDate.getTime())) {
        formattedDate = format(
          parsedDate,
          GlobalVariable.userDet.tenantConfig.dateFormat
        );
      } else {
      }
    }
    return <div>{formattedDate}</div>;
  };

  const idateBodyTemplate = (rowData) => {
    let formattedDate = "-";
    if (rowData.invoiceDate !== null) {
      const parsedDate = new Date(rowData.invoiceDate);
      if (!isNaN(parsedDate.getTime())) {
        formattedDate = format(
          parsedDate,
          GlobalVariable.userDet.tenantConfig.dateFormat
        );
      } else {
      }
    }
    return <div>{formattedDate}</div>;
  };

  const columns = [
    { field: "companyName", header: "Company Name", sortable: false, body: "" },
    {
      field: "invoiceDate",
      header: "Invoice Date",
      sortable: false,
      body: "idateBodyTemplate",
    },
    {
      field: "discountAmount",
      header: "Discount Amount",
      sortable: false,
      body: "disAmountBodyTemplate",
    },
  ];

  const statusBodyTemplate = (rowData) => {
    let status = rowData.status.toUpperCase();
    let statusClass;
    switch (status) {
      case "OPEN":
        statusClass = "orange";
        break;
      case "PARTIALLY PAID":
        statusClass = "processing";
        break;
      case "PAID":
        statusClass = "green";
        break;
      case "DRAFT":
        statusClass = "purple";
        break;
      case "OVERDUE":
        statusClass = "error";
        break;
      default:
        statusClass = "cyan";
    }

    return (
      <>
        {" "}
        <Tag bordered={false} color={statusClass}>
          {status}
        </Tag>
      </>
    );
  };

  const reject = () => {};
  const confirmDelete = (rowData) => {
    let obj = {
      className: "pAdj deletecircle",
      message: "Are you sure you want to proceed?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      defaultfocus: "accept",
      accept: () => DeleteSalesInvoice(rowData),
      reject: () => reject(),
    };
    confirmDialog(obj);
  };

  const DeleteSalesInvoice = (rowData) => {
    is.DeleteSalesInvoice(
      GlobalVariable.userDet.tenantDetail.tenantID,
      rowData.salesInvoiceID,
      0
    ).then((res) => {
      if (res.data.statusCode === 200) {
        toast.current.show({ severity: "success", summary: res.data.message });
      }
      invoiceGrid(page, sizePerPage, searchVal, "", "", "");
    });
  };
  const [editModeData, setEditModeData] = useState({});

  const editData = (rowData) => {
    setInvoiceType(
      rowData.invoiceType === "SalesInvoice"
        ? "invoice"
        : rowData.invoiceType === "ProformaInvoice"
        ? "Proforma"
        : "export"
    );
    setEditModeData(rowData);
    setEditModeData(rowData);
    if (rowData.status === "RECURRING") {
      setEditable(false);
    } else {
      setEditable(rowData.status !== "DRAFT");
    }
setisManual(false);
    setIsNewvoice(!isNewvoice);
    setIsType(true);
    setIsUpdate(true);
    setIsCustChoose(false);
    setIsDiscountDisabled(false);
    const bindBilltoValue =
      billToDropDown.find((a) => a.firstName === rowData.firstName) || null;
    setSelectedBillToDropDown(bindBilltoValue);
    setValue("billto", bindBilltoValue);
    handleSelectToBillDropdown(bindBilltoValue);
    setInvoiceDate(
      rowData.invoiceDate ? new Date(rowData.invoiceDate) : new Date()
    );
    const billingDate = rowData.selectdate
      ? new Date(rowData.selectdate)
      : new Date();
    setSelectDate(billingDate);
    setValue("selectdate", billingDate);
    setValue(
      "paymentduedate",
      rowData.dueDate ? new Date(rowData.dueDate) : ""
    );

    setInvoiceNumberD(rowData.invoiceNumber);
    setValue("ponumber", rowData.orderNumber);
    const termname = termName.find((a) => a.name === rowData.termName) || null;
    setSelectedTerm(termname);
    setValue("term", termname);
    const btype = frequencyType.find((a) => a.name === rowData.frequency);
    if (btype) {
      setSelectedType(btype?.value);
      setValue("billingType", btype);
    } else {
      setSelectedType(frequencyType[0].value);
      setValue("billingType", frequencyType[0].value);
    }
    setSubTotal(rowData.subTotal);
    setShipCharge(rowData.shippingCharge);
    setRoundOff(rowData.roundOff?.toFixed(2));
    setDiscountValue(rowData.discountRate);
    setSgstTax(rowData.localTaxRate);
    setCgstTax(rowData.centralTaxRate);
    setIgstTax(rowData.interTaxRate);
    setNetAmountValue(rowData.totalAmount);
    setDiscountedAmount(rowData.discountAmount?.toFixed(2));
    setSgstTaxAmount(rowData.localTaxAmount);
    setCgstTaxAmount(rowData.centralTaxAmount);
    setIgstTaxAmount(rowData.interTaxAmount);

    const productDetails = rowData.salesItemsList.map((a, i) => ({
      id: i + 1,
      productname: productDrop.find((x) => x.name === a.itemName) || "",
      quantity: a.quantity || "",
      rate: a.rate || "",
      btlperbox: a.secQuantity,
      discount: a.discount || 0,
      statetax: a.localTaxRate || 0,
      centraltax: a.centralTaxRate || 0,
      intertax: a.interTaxRate || 0,
      netamount: a.totalAmount?.toFixed(2) || "",
      producttype: a.itemType || "",
      salesItemID: a.salesItemID || 0,
      salesInvoiceID: a.salesInvoiceID || 0,
      description: a.description || "",
      code: a.hsnCode || "",
      manufacEndDate: a.manufacEndDate || "",
      manufacStartDate: a.manufacStartDate || "",
      batchNo: a.batchNo || "",
      terUnit: a.terUnit || "",
      terQuantity: a.terQuantity || "",
    }));

    setInvoiceLines(productDetails);
    setValue("contact", rowData.invContact || "");
    setValue("buyersref", rowData.buyersRef || "");
    setValue(
      "buyersrefdate",
      rowData.buyersRefDate ? new Date(rowData.buyersRefDate) : null
    );
    if (rowData.orgAddressID) {
      const ob =
        tenantDetailsOrg?.find(
          (b) => b.orgAddressID === rowData.orgAddressID
        ) || null;
      setValue("billfrom", ob);
      const st =
        shippingAddressOptions.find(
          (c) => c.shippingAddressID === rowData.shippingAddressID
        ) || null;
      setValue("shipmentto", st);
    } else {
      reset({
        billfrom: "",
        shipmentto: "",
      });
    }
    setValue("originatingFrom", rowData.originatingFrom || "");
    setValue("destination", rowData.destination || "");
    setValue("deliveryPoint", rowData.deliveryPoint || "");
    setValue("despatchDetails", rowData.despatchDetails || "");
    setValue("portOfLoading", rowData.portOfLoading || "");
    setValue("portOfDischarge", rowData.portOfDischarge || "");
    setValue("shipmentType", rowData.shipmentType || "");
    setValue("remark", rowData.orderNumber || "");

    setValue("grossWeight", rowData.grossMass || "");
    setValue("netWeight", rowData.netWeight || "");
    setValue("totalLiters", rowData.totalLitres || "");
    setValue("coo", rowData.coo || "");
    setValue("contactName", rowData.cpName || "");
    setValue("contactEmail", rowData.cpEmail || "");
    setValue("contactPhone", rowData.cpPhone || "");
  };

  const onHide = () => {
    setShowDocument(false);
  };
  const proceedPay = (data, page) => {
    data.page = page;
    setPayment(data);
    paymodal.current.alertToggle(data);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="d-flex">
        <div className="row">
          <div className="col-md d-flex p-0">
            <Tooltip title="Edit">
              <IcomoonReact
                iconSet={iconSet}
                color="#1763af"
                size={20}
                icon="edit"
                className="pointer custom-edit-icon"
                onClick={() => editData(rowData)}
              />
            </Tooltip>

            {rowData.status !== "RECURRING" && rowData.status !== "DRAFT" && (
              <Tooltip title="View Invoice">
                <i
                  className="pi pi-file-pdf icon-tooltip ms-2"
                  style={{ color: "crimson", fontSize: "1.4rem" }}
                  onClick={() => DownloadDocs(rowData)}
                ></i>
              </Tooltip>
            )}

            {rowData.status !== "RECURRING" &&
              rowData.status === "DRAFT" &&
              JSON.parse(localStorage.getItem("checkAccess"))?.deleteAccess && (
                <Tooltip title="Delete">
                  <IcomoonReact
                    iconSet={iconSet}
                    color="#C20016"
                    size={20}
                    icon="delete"
                    className="pointer ms-2"
                    onClick={() => confirmDelete(rowData)}
                  />
                </Tooltip>
              )}

            {rowData.status !== "DRAFT" && rowData.pacDocID === 0 && (
              <Tooltip title="Generate Packing List">
                <i
                  className="pi pi-box icon-tooltip ms-2"
                  style={{ color: "brown", fontSize: "1.3rem" }}
                  onClick={() => confirmGeneratePackingDoc(rowData)}
                ></i>
              </Tooltip>
            )}

            {rowData.status !== "DRAFT" && rowData.pacDocID !== 0 && (
              <Tooltip title="View Packing List">
                <i
                  className="pi pi-file-pdf icon-tooltip ms-2"
                  style={{ color: "green", fontSize: "1.4rem" }}
                  onClick={() => DownloadPackingDocs(rowData)}
                ></i>
              </Tooltip>
            )}
          </div>

          <Dialog
            visible={showDocument}
            onHide={onHide}
            header="Document"
            modal
            style={{ width: "70%", height: "100%" }}
          >
            {docUrl ? (
              <iframe src={docUrl} style={{ width: "100%", height: "850px" }} />
            ) : (
              <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  top: "50%",
                  fontSize: "1.5rem",
                }}
              >
                No document found
              </div>
            )}
          </Dialog>
        </div>
      </div>
    );
  };

  const totalAmountBodyTemplate = (rowData) => {
    return (
      GlobalVariable.userDet.tenantConfig.currency +
      " " +
      rowData.totalAmount.toFixed(2)
    );
  };
  const blanceDueBodyTemplate = (rowData) => {
    return (
      GlobalVariable.userDet.tenantConfig.currency +
      " " +
      rowData.balancePayment.toFixed(2)
    );
  };
  const disAmountBodyTemplate = (rowData) => {
    return (
      <div className="text-end">
        {" "}
        {GlobalVariable.userDet.tenantConfig.currency +
          " " +
          rowData.discountAmount.toFixed(2)}{" "}
      </div>
    );
  };
  const GetContact = (signal) => {
    const data = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      ContactType: "Customer",
      CustomerType: "all",
      Status: "Active",
    };
    is.GetContact(data, signal).then((res) => {
      setBillToDropDown(res.data.data);
    });
  };

  const handleSelectToBillDropdown = (e) => {
    setIsCustChoose(false);
    setSelectedBillToDropDown(e);
    clearFields();
    setIsType(false);
    setSubTotal(0);
    setDiscountValue(0);
    setSgstTax(0);
    setCgstTax(0);
    setIgstTax(0);
    setRoundOff(0);
    setNetAmountValue(0);
    setShipCharge(0);
    setCgstTaxAmount(0);
    setSgstTaxAmount(0);
    setIgstTaxAmount(0);
    setDiscountedAmount("0.00");
    // e.shippingAddressList = [...e.shippingAddressList]
    // 🔥 NEW: Set the shipping addresses for "Shipment To" dropdown
    if (e?.shippingAddressList?.length > 0) {
      console.log(e.shippingAddressList, "e.shippingAddressList");
      setShippingAddressOptions(e.shippingAddressList);
    } else {
      setShippingAddressOptions([]); // or show “No shipping address found”
    }
  };

  const handleSelectTerm = (e) => {
    setSelectedTerm(e);
    const count = e.count;
    const iDate = new Date(invoiceDate);
    const formattedInvoiceDate = iDate.toISOString().split("T")[0];
    const [year, month, day] = formattedInvoiceDate.split("-");
    const yearInt = parseInt(year);
    const monthInt = parseInt(month) - 1;
    const dayInt = parseInt(day);
    const newDate = new Date(yearInt, monthInt, dayInt + count);
    const formattedDay = String(newDate.getDate()).padStart(2, "0");
    const formattedMonth = String(newDate.getMonth() + 1).padStart(2, "0");
    const formattedNewDate = `${newDate.getFullYear()}-${formattedMonth}-${formattedDay}`;
    setPaymentDueFormat(newDate);
    setPaymentDueDateCount(newDate);
    setValue("paymentduedate", newDate);
  };
  const onInvalid = (errors) => console.error(errors);
  // function formatDate(date) {
  //   const year = date.getFullYear();
  //   let month = (date.getMonth() + 1).toString();
  //   let day = date.getDate().toString();
  //   if (month.length < 2) {
  //     month = "0" + month;
  //   }
  //   if (day.length < 2) {
  //     day = "0" + day;
  //   }
  //   return `${year}-${month}-${day}`;
  // }

  function formatDate(date) {
    return format(date, "yyyy-MM-dd");
  }

  const submitFinalInvoice = (data, status) => {
    const invalidInvoiceLines = invoiceLines.filter(
      (line) =>
        line.productname === "" ||
        line.quantity === "" ||
        line.discount === "" ||
        line.tax === ""
    );

    if (invalidInvoiceLines.length > 0) {
      setManualErr("All fields are required for each invoice line");
      setIsProcess(false);
      return;
    }

    setManualErr("");

    // if (invoiceType === "export" && !isAdditionalInfoSaved) {
    //   setPendingSubmitData({ data, status });
    //   setShowInfoForm(true);
    //   return;
    // }

    onSubmit(data, status);
  };

  const onSubmit = (data, status) => {
    setIsProcess(true);
    const datas = {
      SalesInvoiceID: rowData.salesInvoiceID || 0,
      InvoiceType:
        invoiceType === "invoice"
          ? "SalesInvoice"
          : invoiceType === "Proforma"
          ? "ProformaInvoice"
          : "ExportInvoice",
      InvoiceNumber: invoiceNumberD,
      InvoiceDate: formatDate(new Date(invoiceDate)),
      TermID: 0,
      TermName: selectedTerm.name,
      NumberOfDays: selectedTerm.count,
      DueDate: formatDate(new Date(data.paymentduedate)),
      OrderNumber: data.remark || data.ponumber,
      BuyersRef: data.buyersref,
      BuyersRefDate: formatDate(new Date(data.buyersrefdate)),
      OrgAddressID: data.billfrom.orgAddressID,
      OriginatingFrom: data.originatingFrom,
      Destination: data.destination,
      DeliveryPoint: data.deliveryPoint,
      DespatchDetails: data.despatchDetails,
      InvContact: data.contact,
      SAAttention: selectedShipmentTo?.saAttention || "",
      SAAddress1: selectedShipmentTo?.saAddress1 || "",
      SAAddress2: selectedShipmentTo?.saAddress2 || "",
      SAAddress3: selectedShipmentTo?.saAddress3 || "",
      SACity: selectedShipmentTo?.saCity || "",
      SAState: selectedShipmentTo?.saState || "",
      SACountry: selectedShipmentTo?.saCountry || "",
      SAZipCode: selectedShipmentTo?.saZipCode || "",
      ShippingAddressID: selectedShipmentTo?.shippingAddressID || 0,
      PortOfLoading: data.portOfLoading,
      PortOfDischarge: data.portOfDischarge,
      ShipmentType: data.shipmentType,
InvoiceNoGenType: numberType, 
      IsAddInfo: true,
      GrossMass: data.grossWeight || "",
      NetWeight: data.netWeight || "",
      TotalLitres: data.totalLiters || "",
      Coo: data.coo || "",
      CpName: data.contactName || "",
      CpPhone: data.contactPhone || "",
      CpEmail: data.contactEmail || "",
      CustomerID: selectedBillToDropDown.contactID,
      CustomerGSTIN: selectedBillToDropDown.gstNumber,
      CompanyName: selectedBillToDropDown.companyName,
      FirstName: selectedBillToDropDown.firstName,
      LastName: selectedBillToDropDown.lastName,
      Address1: selectedBillToDropDown.baAddress1,
      Address2: selectedBillToDropDown.baAddress2,
      City: selectedBillToDropDown.saCity,
      State: selectedBillToDropDown.saState,
      ZipCode: selectedBillToDropDown.saZipCode,
      Country: selectedBillToDropDown.saCountry,
      Phone: selectedBillToDropDown.phone,
      Fax: selectedBillToDropDown.saFax,
      Email: selectedBillToDropDown.email,
      SubTotal: subTotal,
      DiscountType: "Percentage",
      DiscountRate: discountValue,
      DiscountAmount: discountedAmount,
      LocalTaxName: countryTaxDetails.localTaxName,
      LocalTaxRate: sgstTax,
      LocalTaxAmount: sgstTaxAmount,
      InterTaxName: countryTaxDetails?.interTaxName,
      InterTaxRate: igstTax,
      InterTaxAmount: igstTaxAmount,
      CentralTaxName: countryTaxDetails?.centralTaxName,
      CentralTaxRate: cgstTax,
      CentralTaxAmount: cgstTaxAmount,
      IsOtherTax: false,
      ShippingCharge: shipCharge,
      RoundOff: roundOff,
      TotalAmount: finalTotal,
      DocID: 0,
      BillingType: selectedType,
      Frequency: selectedType,
      BillingDate: formatDate(new Date(invoiceDate)),
      Status: status || "OPEN",
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      CreatedBy: GlobalVariable.userDet.appUser.appuserID,
      IsItemChanged: true,
      SalesItemsList: invoiceLines.map((a, i) => {
        const quantity = Number(a.quantity || 0);
        const discount = Number(a.discount || 0);
        const rate = Number(a.productname?.siSellingPrice || 0);
        const statetax = Number(a.statetax || 0);
        const centraltax = Number(a.centraltax || 0);
        const intertax = Number(a.intertax || 0);
        const totalTaxPercent = statetax + centraltax + intertax;
        const discountedRate = rate - (rate * discount) / 100;
        const taxedRate =
          discountedRate + (discountedRate * totalTaxPercent) / 100;

        return {
          SalesItemID: a.salesItemID || 0,
          SalesInvoiceID: a.salesInvoiceID || 0,
          ItemID: a.productname.itemID,
          ItemName: a.productname.name,
          ItemType: a.productname.itemType,
          HsnCode: a.code,
          HsnName: a.productname.itemType === "goods" ? "HSN" : "SAC",
          Unit: a.productname.unit,
          IsSecUnit: a.productname.isSecUnit,
          SecUnit: a.productname.secUnit,
          SecQuantity: a.btlperbox || 0,
          BatchNo: a.batchnumber,
          ManufacStartDate: a.mfgstartdate !== "" ? a.mfgstartdate : null,
          ManufacEndDate: a.mfgsenddate !== "" ? a.mfgsenddate : null,
          ItemDescription: a.description,
          TotalTaxPercentage: totalTaxPercent,
          TotalTaxAmount: 0,
          PerItemAmount: taxedRate.toFixed(2),
          Quantity: quantity,
          Rate: rate,
          DiscountType: "Percentage",
          DiscountRate: discountValue,
          Discount: discount,
          LocalTaxName: countryTaxDetails.localTaxName,
          LocalTaxRate: statetax,
          LocalTaxAmount: sgstTaxAmount,
          InterTaxName: countryTaxDetails?.interTaxName,
          InterTaxRate: intertax,
          InterTaxAmount: igstTaxAmount,
          CentralTaxName: countryTaxDetails?.centralTaxName,
          CentralTaxRate: centraltax,
          CentralTaxAmount: cgstTaxAmount,
          IsOtherTax: false,
          TotalAmount: +a.netamount,
          Description: a.productname.piDescription,
          Status: status || "OPEN",
          TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
          CreatedBy: GlobalVariable.userDet.appUser.appuserID,
          TerUnit: a.terUnit ? a.terUnit : "ML",
          TerQuantity: a.terQuantity ? a.terQuantity : a.TerQuantity,
        };
      }),
    };
   is.SaveSalesInvoice(datas)
  .then((res) => {
    const { statusCode, message, errors } = res.data;

    // ❗ Invoice number already exists check
    if (message === "Invoice number is already exist") {
      setIsProcess(false);
      toast.current.show({
        severity: "error",
        summary: "Invoice number already exists",
      });
      return; // STOP further execution
    }

    // ✅ True success
    if (statusCode === 200 && !errors) {
      setIsProcess(false);
      toast.current.show({
        severity: "success",
        summary: message,
      });
      backToAllInvoice();
      return;
    }

    // ❌ Any other API error
    setIsProcess(false);
    toast.current.show({
      severity: "error",
      summary: message || "Something went wrong",
    });
  })
  .catch((err) => {
    setIsProcess(false);
    toast.current.show({
      severity: "error",
      summary: "Network/Server error. Please try again.",
    });
    console.error(err);
  });

  };

  useEffect(() => {
    setIsAdditionalInfoSaved(false);
  }, [invoiceType]);

  const invoiceCancel = () => {
    reset();
    setSelectedBillToDropDown(null);
    setInvoiceDate(new Date());
    setIsType(false);
    setIsUpdate(false);
    setIsCustChoose(true);
    setIsDiscountDisabled(false);
    setNetAmountValue("");
    setPaymentDueDateCount("");
    setSelectProductDrop("");
    setItemType("");
    setProductRate("");
    clearFields();
    setSubTotal(0);
    setDiscountValue(0);
    setSgstTax(0);
    setCgstTax(0);
    setIgstTax(0);
    setRoundOff(0);
    setNetAmountValue(0);
    setShipCharge(0);
    setCgstTaxAmount(0);
    setSgstTaxAmount(0);
    setIgstTaxAmount(0);
    setDiscountedAmount("0.00");
  };

  const invoiceDateselect = (e) => {
    e.stopPropagation();
    setPaymentDueDateCount("");
    setValue("term", "");
    setValue("paymentduedate", "");
    setInvoiceDate(e.target.value);
  };
  const handleInputChangeQuantity = (e, i, selectedProduct) => {
    setManualErr("");
    const inputQuantity = parseFloat(e.target.value) || 0;
    const stockCount = selectedProduct?.stocks || 0;
    const newInvoiceLines = [...invoiceLines];
    if (inputQuantity > stockCount) {
      newInvoiceLines[i].quantityError = `Only ${stockCount} in stock`;
      setInvoiceLines(newInvoiceLines);
      setTimeout(() => {
        const updatedLines = [...newInvoiceLines];
        updatedLines[i].quantityError = "";
        setInvoiceLines(updatedLines);
      }, 3000);
      return;
    }
    newInvoiceLines[i].quantityError = "";
    newInvoiceLines[i].quantity = inputQuantity;
    setQuantityValue(inputQuantity);
    setInvoiceLines(newInvoiceLines);
    let addSubTotal = newInvoiceLines
      .map((a) => a.rate * a.quantity)
      .reduce((acc, ttl) => acc + ttl, 0);
    setSubTotal(addSubTotal);
    handleTaxChangeWithoutIndex(newInvoiceLines, i);
    handleTaxChange(newInvoiceLines);
  };

  // const handleInputChangeDiscount = (e, i) => {
  //   setManualErr("");
  //   const inputValue = e.target.value;
  //   if (inputValue.includes("-")) {
  //     const sanitizedInput = inputValue.replace("-", "");
  //     e.target.value = sanitizedInput;
  //   }
  //   const newInvoiceLines = [...invoiceLines];
  //   newInvoiceLines[i].discount = e.target.value;
  //   setDiscountValue(e.target.value);
  //   setInvoiceLines(newInvoiceLines);
  //   let disPer = newInvoiceLines.map((a) => +a.discount).reduce((acc, total) => acc + total, 0);
  //   let calculatePer = (+disPer * 100) / (newInvoiceLines.length * 100);
  //   let a = calculatePer;
  //   setDiscountValue(a);
  //   handleTaxChangeWithoutIndex(newInvoiceLines, i);
  //   handleTaxChange(newInvoiceLines);
  // };

  const handleInputChangeDiscount = (e, i) => {
    setManualErr("");
    const inputValue = e.target.value;
    if (inputValue.includes("-")) {
      const sanitizedInput = inputValue.replace("-", "");
      e.target.value = sanitizedInput;
    }
    const newInvoiceLines = [...invoiceLines];
    newInvoiceLines[i].discount = e.target.value;
    setDiscountValue(e.target.value);
    setInvoiceLines(newInvoiceLines);
    let disPer = newInvoiceLines
      .map((a) => +a.discount)
      .reduce((acc, total) => acc + total, 0);
    let calculatePer = (+disPer * 100) / (newInvoiceLines.length * 100);
    let a = calculatePer;
    setDiscountValue(a);
    handleTaxChangeWithoutIndex(newInvoiceLines, i);
    handleTaxChange(newInvoiceLines);
  };

  const handleInputChangeStateTax = (e, index) => {
    setManualErr("");
    const newInvoiceLines = [...invoiceLines];
    newInvoiceLines[index].statetax = e.target.value;
    setInvoiceLines(newInvoiceLines);
    handleTaxChangeWithoutIndex(newInvoiceLines, index);
    handleTaxChange(newInvoiceLines);
  };

  const handleInputChangeCentralTax = (e, index) => {
    setManualErr("");
    const newInvoiceLines = [...invoiceLines];
    newInvoiceLines[index].centraltax = e.target.value;
    setInvoiceLines(newInvoiceLines);
    handleTaxChangeWithoutIndex(newInvoiceLines, index);
    handleTaxChange(newInvoiceLines);
  };

  const handleInputChangeInterTax = (e, index) => {
    setManualErr("");
    const newInvoiceLines = [...invoiceLines];
    newInvoiceLines[index].intertax = e.target.value;
    setInvoiceLines(newInvoiceLines);
    handleTaxChangeWithoutIndex(newInvoiceLines, index);
    handleTaxChange(newInvoiceLines);
  };

  const handleTaxChange = (newlines) => {
    setInvoiceLines(newlines);
    let disPer = newlines
      .map((a) => +a.discount)
      .reduce((acc, total) => acc + total, 0);
    let calculatePer = (+disPer * 100) / (newlines.length * 100);
    setDiscountValue(calculatePer);
    let addSubTotal = newlines
      .map((a) => a.rate * a.quantity)
      .reduce((acc, ttl) => acc + ttl, 0);
    setSubTotal(addSubTotal);
    let calculateStateTax = newlines
      .map((a) => {
        const price = a.quantity * a.productname.siSellingPrice;
        const discountedPrice = price - price * (+a.discount / 100);
        return discountedPrice * (+a.statetax / 100);
      })
      .reduce((acc, ttl) => acc + ttl, 0);

    let calculateStateTaxPercentage = newlines
      .map((a) => +a.statetax)
      .reduce((acc, ttl) => acc + ttl, 0);
    setSgstTax(calculateStateTaxPercentage);
    let calculateCentralTax = newlines
      .map((a) => {
        const price = a.quantity * a.productname.siSellingPrice;
        const discountedPrice = price - price * (+a.discount / 100);
        return discountedPrice * (+a.centraltax / 100);
      })
      .reduce((acc, ttl) => acc + ttl, 0);

    let calculateCentralTaxPercentage = newlines
      .map((a) => +a.centraltax)
      .reduce((acc, ttl) => acc + ttl, 0);
    setCgstTax(calculateCentralTaxPercentage);
    let calculateInterTax = newlines
      .map((a) => {
        const price = a.quantity * a.productname.siSellingPrice;
        const discountedPrice = price - price * (+a.discount / 100);
        return discountedPrice * (+a.intertax / 100);
      })
      .reduce((acc, ttl) => acc + ttl, 0);
    let calculateInterTaxPercentage = newlines
      .map((a) => +a.intertax)
      .reduce((acc, ttl) => acc + ttl, 0);
    setIgstTax(calculateInterTaxPercentage);
    setSgstTaxAmount(
      isFinite(calculateStateTax) ? calculateStateTax.toFixed(2) : 0
    );
    setCgstTaxAmount(
      isFinite(calculateCentralTax) ? calculateCentralTax.toFixed(2) : 0
    );
    setIgstTaxAmount(
      isFinite(calculateInterTax) ? calculateInterTax.toFixed(2) : 0
    );
    let roundVal = newlines
      .map((b) => +b.netamount - Math.trunc(+b.netamount))
      .reduce((acc, total) => acc + total, 0);
    setRoundOff(isFinite(roundVal) ? roundVal.toFixed(2) : 0);
    let totalAm = newlines
      .map((b) => +b.netamount)
      .reduce((acc, total) => acc + total, 0);
    setNetAmountValue(isFinite(totalAm) ? totalAm : 0);
  };

  const handleTaxChangeWithoutIndex = (lines, i) => {
    if (!Array.isArray(lines) || lines.length === 0) return;
    if (i == null || i < 0 || i >= lines.length) return; // invalid index check

    const newInvoiceLines = [...lines];
    let total = 0;

    let totalDiscountAmount = newInvoiceLines
      .map((a) => {
        let discountPercentage = parseFloat(a?.discount || 0) / 100;
        let quant = Number(
          (a?.quantity || 0) * (a?.productname?.siSellingPrice || 0)
        );
        return quant * discountPercentage;
      })
      .reduce((acc, ttl) => acc + ttl, 0);

    let discount =
      totalDiscountAmount && isFinite(totalDiscountAmount)
        ? totalDiscountAmount.toFixed(2)
        : "0.00";
    setDiscountedAmount(discount);

    let sgstIndijual = Number(+newInvoiceLines[i]?.statetax || 0);
    setSgstTaxIndijual(sgstIndijual);

    let cgstIndijual = Number(+newInvoiceLines[i]?.centraltax || 0);
    setCgstTaxIndijual(cgstIndijual);

    let igstIndijual = Number(+newInvoiceLines[i]?.intertax || 0);
    setIgstTaxIndijual(igstIndijual);

    let qntyMrate =
      (+newInvoiceLines[i]?.quantity || 0) * (+newInvoiceLines[i]?.rate || 0);
    let discountAmount =
      qntyMrate * ((+newInvoiceLines[i]?.discount || 0) / 100);
    let finalAmount = qntyMrate - discountAmount;

    let collectTax =
      (+newInvoiceLines[i]?.statetax || 0) +
      (+newInvoiceLines[i]?.centraltax || 0) +
      (+newInvoiceLines[i]?.intertax || 0);

    let findTax = (finalAmount * collectTax) / 100;
    total = finalAmount + findTax;

    newInvoiceLines[i].netamount = total.toFixed(2);
  };

  const GetTenantDetails = () => {
    is.GetTenantDetails(GlobalVariable.userDet.tenantDetail.tenantID).then(
      (res) => {
        setTenantDetails(res.data.data);
        setTenantDetailsOrg(res.data.data.originatingAddressList);
        GetCountryTaxName(res.data.data.country);
      }
    );
  };

  const GetCountryTaxName = (country) => {
    is.GetCountryTaxName(country).then((res) => {
      if (res.data.statusCode === 200) {
        setCountryTaxDetails(res.data.data);
      }
    });
  };

  const getShippingCharge = (e) => {
    const newInvoiceLines = [...invoiceLines];
    const charge = +e.target.value;
    setShipCharge(charge);
    let totalAm = newInvoiceLines
      .map((b) => +b.netamount)
      .reduce((acc, total) => acc + total, 0);
    let withShippin = totalAm + charge;
    setNetAmountValue(withShippin);
  };

  const deleteLineItem = (e, index) => {
    const newInvoiceLines = [...invoiceLines];
    if (newInvoiceLines.length <= 1) {
      toast.current.show({
        severity: "error",
        summary:
          "Item deletion is only possible after adding a second line item",
      });
      return;
    }
    toast.current.show({
      severity: "success",
      summary: "Deleted successfully",
    });
    setIsType(true);
    newInvoiceLines.splice(index, 1);
    handleTaxChangeWithoutIndex(
      newInvoiceLines,
      editIndex ?? newInvoiceLines.length - 1
    );
    setInvoiceLines(newInvoiceLines);
    handleTaxChange(newInvoiceLines);
  };

  const confirmGeneratePackingDoc = (rowData) => {
    confirmDialog({
      className: "pAdj deletecircle",
      message: "Are you sure you want to generate the Packing List?",
      header: "Generate Packing List",
      icon: "pi pi-exclamation-triangle",
      // acceptClassName: 'p-button-sm p-button-success',
      // rejectClassName: 'p-button-sm p-button-secondary',
      accept: () => generatePackingDoc(rowData),
      reject: () => reject(),
    });
  };

  const generatePackingDoc = (e) => {
    setIsProcess(true);

    is.GenerateExportTRF(
      GlobalVariable.userDet.tenantDetail.tenantID,
      e.salesInvoiceID,
      "PackingList"
    ).then((res) => {
      if (res.data.message === "Document Generated") {
        toast.current.show({
          severity: "success",
          // summary: "Confirmed",
          detail: "Successfully Generated",
          life: 3000,
        });
        setIsProcess(false);
        invoiceGrid(1, sizePerPage, searchVal, "", "", filterGrid);
      }
    });
  };

  const DownloadPackingDocs = (e) => {
    setIsProcess(true);
    const data = {
      DocIDs: e.pacDocID.toString(),
      DocCategory: "PackingList",
    };
    is.DownloadDocs(data).then((res) => {
      if (res.data.statusCode === 200) {
        setDocUrl(res.data?.data[0]?.documentURL);
        setShowDocument(true);
        setIsProcess(false);
      }
    });
  };
  const DownloadDocs = (e) => {
    setIsProcess(true);
    const data = {
      DocIDs: e.docID.toString(),
      DocCategory: e.invoiceType,
    };
    is.DownloadDocs(data).then((res) => {
      if (res.data.statusCode === 200) {
        setDocUrl(res.data?.data[0]?.documentURL);
        setShowDocument(true);
        setIsProcess(false);
      }
    });
  };
  const invoiceGridEdit = (
    page,
    sizePerPage,
    searchVal,
    sortName,
    sortOrder
  ) => {
    const data = {
      InputParams: {
        TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
        ContactID: 0,
        Status: "",
      },
      ServerSearchables: {
        draw: 1,
        searchData: searchVal || "",
        orderByColumn: sortName,
        orderBy: sortOrder,
        currentPage: 0,
        pageSize: sizePerPage,
        pageNumber: page,
      },
    };
    is.GetSalesInvoiceListSearch(data).then((res) => {
      const val = res.data.data.salesInvoiceList;
      const find = val.filter(
        (x) => x.salesInvoiceID === editModeData.salesInvoiceID
      );
      setEditModeData(find[0]);
    });
  };
  const parentFunction = () => {
    if (payment.page === "editpage") {
      invoiceGridEdit(page, sizePerPage, searchVal, "", "");
    } else {
      invoiceGrid(page, sizePerPage, searchVal, "", "", "");
    }
  };

  const dynamicColumns = selectedColumns.map((col, i) => {
    return (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        sortable={col.sortable}
        body={
          col.body === "idateBodyTemplate"
            ? idateBodyTemplate
            : col.body === "disAmountBodyTemplate"
            ? disAmountBodyTemplate
            : col.body
        }
      ></Column>
    );
  });

  const onColumnToggle = (event) => {
    let selectedColumns = event.value;
    let addCurrency = selectedColumns.find((a) => {
      if (a.header === "Payables" || "Unused Credits") {
      }
    });
    let orderedSelectedColumns = columns.filter((col) =>
      selectedColumns.some((sCol) => sCol.field === col.field)
    );
    setSelectedColumns(orderedSelectedColumns);
  };
  const keySearch = (e) => {
    setSearchVal(e.target.value);
    if (e.key === "Enter") {
      setPage(1);
      invoiceGrid(1, sizePerPage, e.target.value, "", "", "");
    }
    if (e.type === "keyup") {
      if (e.target.value === "") {
        invoiceGrid(1, sizePerPage, "", "", "", "");
      }
    }
    if (e.target.value === "") {
      invoiceGrid(1, sizePerPage, "", "", "", "");
    }
  };

  const customerDetails = (option) => {
    return (
      <div className="flex align-items-center">
        <div>
          {option.companyName} ( {option.fullName} )
        </div>
      </div>
    );
  };

  const changeGridDatasBasedOnStatus = (e) => {
    setFilterGrid(e);
  };
  const changeGridDatasBasedOnInvType = (e) => {
    setInvTypeFilterGrid(e);
  };
  const originalValue = parseFloat(netAmountValue);
  const decimalPart = +(originalValue - Math.floor(originalValue)).toFixed(2);
  const hasDecimal = netAmountValue % 1 !== 0;
  const floorValue = Math.floor(originalValue);
  const ceilValue = Math.ceil(originalValue);
  const roundOptions = [
    { label: `- ${decimalPart}`, value: -decimalPart },
    {
      label: `+ ${(1 - decimalPart).toFixed(2)}`,
      value: +(1 - decimalPart).toFixed(2),
    },
    { label: "0.00", value: 0.0 },
  ];
  const finalTotal = (originalValue + selectedRound).toFixed(2);

  const handleInputChange = (e) => {
    const val = e.target.value;

    if (val === "") {
      setEditedTotal(val);
      return;
    }
    const intVal = parseInt(val, 10);
    if (intVal === floorValue || intVal === ceilValue) {
      setEditedTotal(val);
    }
  };

  const handleTotalSave = () => {
    if (editedTotal === "" || isNaN(parseInt(editedTotal, 10))) {
      setNetAmountValue(originalValue.toFixed(2));
    } else {
      setNetAmountValue(parseInt(editedTotal, 10).toFixed(2));
    }
    setIsEditingTotal(false);
  };

  const renderFooter = (name) => (
    <div>
      <Button
        label="Cancel"
        onClick={() => {
          mReset();
          setEditIndex(null);
          setdisplaynewItem(false);
          setIsScroll(false)
        }}
        className="p-button-text btn-cancel"
      />

      <Button
        label="Ok"
        type="button"
        onClick={() => modalHandleSubmit(modelOnSubmit)()}
        className="btn btn-primary"
      />
    </div>
  );

  useEffect(() => {
    setFirst1(0);
    invoiceGrid(1, sizePerPage, searchVal, "", "", filterGrid);
  }, [filterGrid, invTypeFilterGrid]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (itemData?.type) {
      const filtered = productDrop.filter(
        (item) => item.itemType === itemData.type
      );
      setGoodsOrServiceItems(filtered);
    }
  }, [itemData, productDrop]);

  const handleTypeChange = (type) => {
    setSelectedItem(null);
    setIsDisabled(false);
    const filteredItems = productDrop.filter((item) => item.itemType === type);

    setGoodsOrServiceItems(filteredItems);
  };

  useEffect(() => {
    if (selectedItem?.itemID) {
      const updatedLines = invoiceLines.map((line, index) => {
        if (!line.productname) return line;

        if (line.productname.itemID === selectedItem.itemID) {
          return {
            ...line,
            productname: selectedItem,
          };
        }
        return line;
      });

      setInvoiceLines(updatedLines);
    }
  }, [selectedItem]);

  const modelOnSubmit = (data) => {
    if (!selectedItem) return;
    const isIntraState = tenantDetails.state === selectedBillToDropDown.baState;
    const quantity = Number(data.quantity || 1);
    const discount = Number(data.discount || 0);
    const noofbox = Number(data.noofbox || 0);
    const btlperbox = Number(data.per || 0);
    const price = Number(selectedItem.siSellingPrice || 0);
    const grossAmount = price * quantity;
    const discountedAmount = grossAmount - (grossAmount * discount) / 100;
    const newLine = {
      id: editIndex !== null ? invoiceLines[editIndex]?.id : Date.now(),
      productname: selectedItem,
      quantity,
      // noofbox,
      btlperbox,
      batchnumber: data.batchno || "",
      description: data.description || "",
      mfgstartdate: data.mfgsdate || "",
      mfgsenddate: data.mgfedate || "",
      isesecunit: data.name.isSecUnit,
      rate: price.toFixed(2),
      discount,
      code: data.code || selectedItem.productname.saCorHSNCode,
      statetax: isIntraState ? selectedItem.localTaxRate : 0,
      centraltax: isIntraState ? selectedItem.centralTaxRate : 0,
      intertax: isIntraState ? 0 : selectedItem.interTaxRate,
      producttype: selectedItem.itemType,
      netamount: discountedAmount.toFixed(2),
      TerQuantity: btlperbox * selectedItem.terStocks,
    };
    let updatedLines = [];
    if (editIndex !== null) {
      updatedLines = [...invoiceLines];
      updatedLines[editIndex] = newLine;
    } else {
      updatedLines = [...invoiceLines, newLine];
    }
    handleTaxChangeWithoutIndex(
      updatedLines,
      editIndex ?? updatedLines.length - 1
    );
    handleTaxChange(updatedLines);
    setInvoiceLines(updatedLines);
    setIsType(true);
    setSelectProductDrop(selectedItem);
    setItemType(selectedItem);
    setProductRate(selectedItem);
    setdisplaynewItem(false);
    setEditIndex(null);
    setIsScroll(false)

  };

  const modelReset = (e) => {
    console.log("e", e);
    setSecStocks(e.value.secStocks);
    setUnitLabel(e.value.unit);
    setSecUnitLabel(e.value.secUnit);

    modalReset({
      ...modalGetValues(),
      name: e.value,
      unit: e.value.unit,
      code: e.value.saCorHSNCode,
      taxpreference:
        e.value.taxPreference === null ? "Non-taxable" : e.value.taxPreference,
      cgst: e.value.centralTaxRate,
      sgst: e.value.localTaxRate,
      igst: e.value.interTaxRate,
      sellingprice: e.value.siSellingPrice,
      description: e.value.siDescription,
      costprice: e.value.piCostPrice,
      description1: e.value.piDescription,
      stocks: e.value.stocks,
      status: e.value.status === "Active" ? "Active" : "Inactive",
      salescheck: !!e.value.siSellingPrice,
      costcheck: !!e.value.piCostPrice,
    });
  };

  const noofbox = modalWatch("quantity");
  const totalBottles = noofbox && secStocks ? noofbox * secStocks : "";
  const perCount = noofbox && secStocks && secStocks;

  const mReset = () => {
    modalReset({
      type: "goods",
      name: "",
      code: "",
      unit: "",
      stocks: "",
      status: false,
      taxpreference: "",
      cgst: "",
      sgst: "",
      igst: "",
      salescheck: false,
      costcheck: false,
      sellingprice: "",
      costprice: "",
      description: "",
      description1: "",
    });
    setSelectedItem(null);
    setIsDisabled(false);
  };

  function calculateAmount({
    quantity,
    sellingPrice,
    discount = 0,
    cgst = 0,
    sgst = 0,
    igst = 0,
  }) {
    const baseAmount = quantity * sellingPrice;
    const discountedAmount = baseAmount - baseAmount * (discount / 100);
    const taxRate = cgst + sgst + igst;
    const taxAmount = discountedAmount * (taxRate / 100);
    const netAmount = discountedAmount + taxAmount;

    return {
      baseAmount,
      discountedAmount,
      taxAmount,
      netAmount,
      perItemRate: netAmount / quantity,
    };
  }

  const invoiceColumns = [
    "S.No",
    "Product Code",
    "Quantity",
    "No. of Box",
    "Discount",
    "Tax",
    "Per Item Rate",
    "Net Amount",
    "Action",
  ];

  function handleAddToTable(data) {
    const calc = calculateAmount(data);
    setInvoiceItems((prev) => [...prev, { ...data, ...calc }]);
    setdisplaynewItem(false);
  }

  const formatDateForInput = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
  };

  function handleEdit(item, index) {
    const currentType = item.producttype;
    const filteredItems = productDrop.filter(
      (prod) => prod.itemType === currentType
    );
    setGoodsOrServiceItems(filteredItems);

    modalSetValue("type", currentType);
    const matchedItem = filteredItems.find(
      (g) =>
        g.itemID === item.productname?.itemID ||
        g.name === item.productname?.name
    );

    if (rowData) {
      setSecStocks(item.productname.secStocks);
    }

    setSelectedItem(matchedItem || null);
    setEditIndex(index);

    modalReset({
      ...modalGetValues(),
      name: matchedItem || null,
      quantity: item.quantity,
      discount: item.discount,
      noofbox: item.quantity,
      btlperbox: item.btlperbox,
      type: item.producttype,
      unit: item.productname.unit,
      code: item.code ? item.code : matchedItem?.saCorHSNCode || "",
      taxpreference: item.productname.taxPreference ?? "Non-taxable",
      cgst: item.centraltax,
      sgst: item.statetax,
      igst: item.intertax,
      sellingprice: item.rate,
      description: item.description || item.productname.siDescription,
      costprice: item.productname.piCostPrice,
      stocks: item.productname.stocks,
      status: item.productname.status ?? "Inactive",
      salescheck: !!item.productname.siSellingPrice,
      costcheck: !!item.productname.piCostPrice,
      mfgsdate: formatDateForInput(item.manufacStartDate),
      mgfedate: formatDateForInput(item.manufacEndDate),
      batchno: item.batchNo || "",
    });

    setdisplaynewItem(true);
    setIsDisabled(true);
  }

  const handleDelete = (item) => {
    setItems((prev) => prev.filter((i) => i !== item));
  };

  const handleAddItem = (itemData) => {
    const calculated = calculateAmount(itemData);
    setItems((prevItems) => [...prevItems, { ...itemData, ...calculated }]);
  };

  useEffect(() => {
    modalSetValue("per", totalBottles);
  }, [totalBottles]);

  const watchType = watch("type");

  useEffect(() => {
    if (watchType) {
      handleTypeChange(watchType);
    }
  }, [watchType]);

  useEffect(() => {
    if (
      editModeData &&
      editModeData.shippingAddressID &&
      shippingAddressOptions.length > 0
    ) {
      const matchedAddress = shippingAddressOptions.find(
        (addr) => addr.shippingAddressID === editModeData.shippingAddressID
      );

      if (matchedAddress) {
        setValue("shipmentto", matchedAddress);
        setSelectedShipmentTo(matchedAddress);
      }
    }
  }, [editModeData, shippingAddressOptions]);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    invoiceGrid(page, sizePerPage, searchVal, "", "", "");
    GetContact(signal);
    GetSalesItemList();
    GenerateConfigNumber();
    GetTenantDetails();
     return () => {
    controller.abort();
  };
  }, []);

  return (
    <div>
      <InvoicePayment
        ref={paymodal}
        data={{ payment }}
        parentFunction={parentFunction}
      />
      <BlockUI blocked={isProcess}>
        <Toast ref={toast} />
        {isNewvoice && (
          <div className="row mx-auto">
            <div className="card card-borderless cc-greyCard-custm mb-3">
              <div className="ms-2 my-2 me-2">
                <div className="d-flex justify-content-between flex-wrap my-2">
                  <h4 className="m-0">Invoice</h4>
                  <div className="d-flex justify-content-end  kk-table-header kk-header-sec cc-font-size-14">
                    <div className="col ">
                      <Primedropdown
                        value={filterGrid}
                        onChange={(e) => {
                          changeGridDatasBasedOnStatus(e.value);
                        }}
                        options={itemStatus}
                        optionLabel="label"
                        placeholder="Select status to filter"
                        className="col-auto text-start me-3 my-auto"
                      />
                      <Primedropdown
                        value={invTypeFilterGrid}
                        onChange={(e) => {
                          changeGridDatasBasedOnInvType(e.value);
                        }}
                        options={invoiceTypeList}
                        optionLabel="label"
                        placeholder="Select status to filter"
                        className="col-auto text-start me-3 my-auto"
                      />
                      <Space.Compact className=" my-auto">
                        <Input
                          addonBefore={<SearchOutlined />}
                          allowClear
                          placeholder="Search"
                          value={searchVal}
                          onChange={(e) => keySearch(e)}
                          onKeyUp={(e) => keySearch(e)}
                        />
                      </Space.Compact>
                    </div>
                    <button
                      className="btn btn-primary py-1 me-2 mx-2 kk-btnThin my-auto"
                      type="button"
                      onClick={createNewInvoice}
                    >
                      <VscNewFile className="me-1" />
                      Create New Invoice
                    </button>
                    <MultiSelect
                      className="kk-btnThin my-auto"
                      value={selectedColumns}
                      options={columns}
                      optionLabel="header"
                      optionDisabled="disabled"
                      onChange={onColumnToggle}
                      style={{ width: "3em" }}
                      scrollHeight="400px"
                      dropdownIcon="pi pi-table"
                      tooltip="Custom Columns"
                      tooltipOptions={{ position: "top" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="p-0">
              <DataTable
                stripedRows
                className="cc-greyCard-custm1"
                value={invoiceGridDatas}
                totalRecords={totalRecords}
                tableStyle={{ minWidth: "100%" }}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                lazy
                paginator
                loading={isProcess}
                first={first1}
                rows={sizePerPage}
                onPage={onCustomPage1}
                onSort={onSort}
                sortField={lazyParams.sortField}
                sortOrder={lazyParams.sortOrder}
                rowsPerPageOptions={[10, 20, 50]}
                onRowClick={handleRowClick}
              >
                <Column
                  field="invoiceNumber"
                  header="Invoice Number"
                  style={{ width: "15%" }}
                ></Column>
                <Column field="email" header="Email"></Column>
                <Column
                  field="nameBodyTemplate"
                  header="Customer Name"
                  body={nameBodyTemplate}
                ></Column>
                <Column
                  field="dateBodyTemplate"
                  header="Due Date"
                  body={dateBodyTemplate}
                ></Column>
                <Column
                  field="totalAmountBodyTemplate"
                  header="Amount"
                  body={totalAmountBodyTemplate}
                  className="text-end ph"
                ></Column>
                <Column
                  field="blanceDueBodyTemplate"
                  header="Balance Due"
                  body={blanceDueBodyTemplate}
                  className="text-end ph"
                  style={{ justifyContent: "end" }}
                ></Column>
                <Column
                  field="statusBodyTemplate"
                  header="Status"
                  body={statusBodyTemplate}
                ></Column>
                {dynamicColumns}
                <Column
                  field="actionBodyTemplate"
                  header="Action"
                  body={actionBodyTemplate}
                ></Column>
              </DataTable>
            </div>
          </div>
        )}
        <ConfirmDialog />
        {!isNewvoice && (
          <form>
            <div>
              <div className="row mx-auto">
                <div
                  className="col-md d-flex justify-content-between align-items-center my-3 p-3 rounded-3 shadow-sm"
                  style={{
                    background: "white",
                    color: "white",
                  }}
                >
                  <div>
                    {!isUpdate ? (
                      <h3 className="mb-0 " style={{ fontFamily: "unset" }}>
                        <i className="pi pi-file-plus me-2"></i>
                        Create New Invoice
                      </h3>
                    ) : (
                      <h3 className="mb-0 " style={{ fontFamily: "unset" }}>
                        <i className="pi pi-file-edit me-2"></i>
                        Update Invoice
                      </h3>
                    )}
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-danger "
                      onClick={backToAllInvoice}
                      style={{
                        border: "none",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i className="pi pi-arrow-left me-2"></i>
                      Back
                    </button>
                  </div>
                </div>
              </div>

              <div className="card border-0 shadow-sm rounded-3 p-3">
                <div
                  className="container-fluid border-0 p-0"
                  style={{ background: " #E3F2FD", minHeight: "100vh" }}
                >
                  <div className="card border-0 ">
                    <div className="card-body border-0 p-0">
                      <div
                        className="row m-2 g-3"
                        style={{ border: "6px solid #E3F2FD" }}
                      >
                        <div className="col-md-12">
                          <div className=" h-100 p-3 ">
                            <div className="row p-0">
                              <div className="mb-3 d-flex gap-4 align-items-center">
                                <label className="  m-0">Invoice Type:</label>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="invoiceType"
                                    id="invoice"
                                    value="invoice"
                                    checked={invoiceType === "invoice"}
                                    disabled={editable}
                                    onChange={(e) =>
                                      setInvoiceType(e.target.value)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="invoice"
                                  >
                                    Invoice
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="invoiceType"
                                    id="export"
                                    value="export"
                                    checked={invoiceType === "export"}
                                    disabled={editable}
                                    onChange={(e) =>
                                      setInvoiceType(e.target.value)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="export"
                                  >
                                    Export
                                  </label>
                                </div>
                                {/* <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="invoiceType"
                                    id="Proforma"
                                    value="Proforma"
                                    checked={invoiceType === "Proforma"}
                                    disabled={editable}
                                    onChange={(e) =>
                                      setInvoiceType(e.target.value)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="Proforma"
                                  >
                                    Proforma
                                  </label>
                                </div> */}
                              </div>

<div className="col-md-3 mb-3">
  <label className="form-label d-flex align-items-center justify-content-start">
    <span>Invoice Number:</span>

   {isManual && <span className="d-flex gap-3 ms-4">
      <div className="form-check me-3 p-0">
        <input
          className="form-check-input"
          type="radio"
          name="numberType"
          value="auto"
          checked={numberType === "auto"}
          onChange={() => setNumberType("auto")}
        />
        <label className="form-check-label small">Auto</label>
      </div>

      <div className="form-check m-0 p-0">
        <input
          className="form-check-input"
          type="radio"
          name="numberType"
          value="manual"
          checked={numberType === "manual"}
          onChange={() => setNumberType("manual")}
        />
        <label className="form-check-label small">Manual</label>
      </div>
    </span>}
  </label>

  <input
    name="invoicenumber"
    type="text"
    className="form-control"
    value={invoiceNumberD}
    disabled={numberType === "auto"} // Auto → disabled, Manual → editable
    onChange={(e) => {
      if (numberType === "manual") setInvoiceNumberD(e.target.value);
    }}
  />
</div>


                              <div className="col-md-3 mb-1">
                                <label className="form-label ">
                                  Invoice Date
                                </label>
                                <Calendar
                                  name="invoicedate"
                                  value={invoiceDate}
                                  showIcon
                                  className="form-control border-0 rounded-3 bg-white p-0"
                                  onChange={(e) => invoiceDateselect(e)}
                                  placeholder="Select invoice date"
                                  dateFormat="mm/dd/yy"
                                  disabled={editable}
                                />
                                {errors.invoicedate && (
                                  <small className="text-danger d-block mt-1">
                                    <i className="pi pi-exclamation-triangle me-1"></i>
                                    This field is required
                                  </small>
                                )}
                              </div>
                              <div className="col-md-3 mb-3">
                                <label className="form-label required">
                                  Term
                                </label>
                                <Controller
                                  name="term"
                                  control={control}
                                  rules={{ required: true }}
                                  render={({ field }) => (
                                    <Dropdown
                                      {...field}
                                      value={field.value || ""}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        handleSelectTerm(e.value);
                                      }}
                                      options={
                                        Array.isArray(termName) ? termName : []
                                      }
                                      optionLabel="name"
                                      placeholder="Select Term"
                                      className="form-control border-0 custom-placeholder  rounded-3"
                                      disabled={editable}
                                    />
                                  )}
                                />
                                {errors.term && (
                                  <small className="text-danger d-block mt-1">
                                    This field is required
                                  </small>
                                )}
                              </div>
                              <div className="col-md-3 mb-2">
                                <label className="form-label ">
                                  Payment Due Date
                                </label>
                                <Calendar
                                  name="paymentduedate"
                                  value={getValues("paymentduedate")}
                                  className="form-control border-0  rounded-3 bg-white p-0"
                                  disabled
                                  placeholder="Select due date"
                                  {...register("paymentduedate")}
                                />
                              </div>
                              <div className="col-md-3 mb-3">
                                <label className="required">Contact</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register("contact", { required: true })}
                                  disabled={editable}
                                />
                                {errors.contact && (
                                  <small className="text-danger d-block mt-1">
                                    Contact is required
                                  </small>
                                )}
                              </div>

                              <div className="col-md-3 mb-3">
                                <label className="required">Buyer's Ref</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register("buyersref", { required: true })}
                                  disabled={editable}
                                />
                                {errors.buyersref && (
                                  <small className="text-danger d-block mt-1">
                                    Buyer's Ref is required
                                  </small>
                                )}
                              </div>

                              <div className="col-md-3 mb-3">
                                <label className="required">
                                  Buyer's Ref Date
                                </label>
                                <Controller
                                  name="buyersrefdate"
                                  control={control}
                                  rules={{ required: true }}
                                  render={({ field }) => (
                                    <Calendar
                                      {...field}
                                      showIcon
                                      className="form-control border-0 custom-placeholder   rounded-3 bg-white p-0"
                                      placeholder="Select date"
                                      dateFormat="mm/dd/yy"
                                      disabled={editable}
                                    />
                                  )}
                                />
                                {errors.buyersrefdate && (
                                  <small className="text-danger d-block mt-1">
                                    Date is required
                                  </small>
                                )}
                              </div>

                              <div className="col-md-3  ">
                                <label className="required">Bill From</label>
                                <Controller
                                  name="billfrom"
                                  control={control}
                                  rules={{ required: true }}
                                  render={({ field }) => (
                                    <Dropdown
                                      {...field}
                                      value={field.value || ""}
                                      onChange={(e) => {
                                        field.onChange(e);
                                      }}
                                      options={
                                        Array.isArray(tenantDetailsOrg)
                                          ? tenantDetailsOrg
                                          : []
                                      }
                                      itemTemplate={(option) => (
                                        <div>
                                          {[
                                            option.city,
                                            option.state,
                                            option.country,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                        </div>
                                      )}
                                      valueTemplate={(option) =>
                                        option ? (
                                          <div>
                                            {[
                                              option.city,
                                              option.state,
                                              option.country,
                                            ]
                                              .filter(Boolean)
                                              .join(", ")}
                                          </div>
                                        ) : (
                                          <span>Select Bill from Address</span>
                                        )
                                      }
                                      optionLabel="name"
                                      // placeholder="Select bill from"
                                      className="form-control border-0  rounded-3 "
                                      disabled={editable}
                                    />
                                  )}
                                />
                                {errors.billfrom && (
                                  <small className="text-danger d-block mt-1">
                                    This field is required
                                  </small>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="row g-3 m-2"
                        style={{ border: "6px solid #E3F2FD", padding: "5px" }}
                      >
                        <div className="col-md-6 d-flex flex-column gap-3 mb-2">
                          <div className=" border-0">
                            <div className="">
                              <label className=" required">Bill To</label>
                              <Controller
                                name="billto"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                  <Dropdown
                                    {...field}
                                    value={field.value || ""}
                                    filter
                                    onChange={(e) => {
                                      field.onChange(e.value);
                                      handleSelectToBillDropdown(e.value);
                                    }}
                                    options={
                                      Array.isArray(billToDropDown)
                                        ? billToDropDown
                                        : []
                                    }
                                    optionLabel="companyName"
                                    itemTemplate={customerDetails}
                                    placeholder="Select Customer"
                                    className="w-100 border-0 shadow-sm rounded-3 mb-3"
                                    disabled={editable}
                                  />
                                )}
                              />
                              {errors.billto && (
                                <div className="text-danger small mb-2">
                                  {errors.billto.message}
                                </div>
                              )}
                              {!isCustChoose && selectedBillToDropDown ? (
                                <>
                                  <p
                                    className="fw-bold text-white m-0 px-3 pt-2"
                                    style={{ backgroundColor: "#264A84" }}
                                  >
                                    {selectedBillToDropDown.fullName}
                                  </p>
                                  <p
                                    className="mb-0 text-white px-3"
                                    style={{ backgroundColor: "#264A84" }}
                                  >
                                    {selectedBillToDropDown.baAddress1}
                                  </p>
                                  <p
                                    className="mb-0 text-white px-3"
                                    style={{ backgroundColor: "#264A84" }}
                                  >
                                    {selectedBillToDropDown.baState},{" "}
                                    {selectedBillToDropDown.baZipCode}
                                  </p>
                                  <p
                                    className="mb-0 text-white px-3 pb-2"
                                    style={{ backgroundColor: "#264A84" }}
                                  >
                                    <i className="pi pi-phone  me-2"></i>
                                    {selectedBillToDropDown.phone}
                                    <i className="pi pi-envelope  ms-3 me-2"></i>
                                    {selectedBillToDropDown.email}
                                  </p>
                                </>
                              ) : (
                                <div className="alert alert-warning py-2 px-3 rounded-3 mt-2">
                                  <i className="pi pi-info-circle me-2"></i>
                                  Select a customer to view details
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="  border-0">
                            <div className=" rounded-3">
                              <label className="required">Shipment To</label>
                              <Controller
                                name="shipmentto"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                  <Dropdown
                                    {...field}
                                    value={field.value || ""}
                                    filter
                                    onChange={(e) => {
                                      field.onChange(e.value);
                                      setSelectedShipmentTo(e.value);
                                    }}
                                    options={
                                      Array.isArray(shippingAddressOptions)
                                        ? shippingAddressOptions
                                        : []
                                    }
                                    optionLabel="saAddress1"
                                    placeholder="Select Shipment Address"
                                    className="w-100 border-0 shadow-sm rounded-3 mb-3"
                                    disabled={editable}
                                    itemTemplate={(option) => (
                                      <div>
                                        {[
                                          option.saAddress1,
                                          option.saAddress2,
                                          option.saAddress3,
                                          option.saCity,
                                          option.saState,
                                          option.saZipCode,
                                        ]
                                          .filter(Boolean)
                                          .join(", ")}
                                        {option.saAttention && (
                                          <span style={{ fontStyle: "italic" }}>
                                            {" "}
                                            - {option.saAttention}
                                          </span>
                                        )}
                                      </div>
                                    )}
                                    valueTemplate={(option) =>
                                      option ? (
                                        <div>
                                          {[
                                            option.saAddress1,
                                            option.saAddress2,
                                            option.saAddress3,
                                            option.saCity,
                                            option.saState,
                                            option.saZipCode,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                          {option.saAttention && (
                                            <span
                                              style={{ fontStyle: "italic" }}
                                            >
                                              {" "}
                                              - {option.saAttention}
                                            </span>
                                          )}
                                        </div>
                                      ) : (
                                        <span>Select Shipment Address</span>
                                      )
                                    }
                                  />
                                )}
                              />
                              {errors.shipmentto && (
                                <div className="text-danger small mb-2">
                                  <i className="pi pi-exclamation-triangle me-1"></i>
                                  {errors.shipmentto.message}
                                </div>
                              )}
                              {!selectedShipmentTo && (
                                <div className="alert alert-warning py-2 px-3 rounded-3 mt-2">
                                  <i className="pi pi-info-circle me-2"></i>
                                  Select a shipment address to view details
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 mt-2">
                          <div className="h-100 border-0">
                            <div className="card-body rounded-3 pt-1">
                              <div className="row mb-3">
                                <div className="col-md-6">
                                  <label>
                                    {" "}
                                    {invoiceType === "export"
                                      ? "Shipped From"
                                      : "Originating From"}
                                  </label>
                                  <input
                                    {...register("originatingFrom")}
                                    type="text"
                                    className="form-control custom-placeholder"
                                    placeholder="e.g. MAHARASHTRA"
                                    disabled={editable}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>
                                    {invoiceType === "export"
                                      ? "Place of Delivery"
                                      : "Destination"}
                                  </label>
                                  <input
                                    {...register("destination")}
                                    type="text"
                                    className="form-control custom-placeholder"
                                    placeholder="e.g. TAMILNADU"
                                    disabled={editable}
                                  />
                                </div>
                              </div>

                              <div className="row mb-3">
                                <div className="col-md-6">
                                  <label>Despatch Mode</label>
                                  <input
                                    {...register("despatchDetails")}
                                    type="text"
                                    className="form-control custom-placeholder"
                                    placeholder="e.g. By Road"
                                    disabled={editable}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>Delivery Point</label>
                                  <input
                                    {...register("deliveryPoint")}
                                    type="text"
                                    className="form-control custom-placeholder"
                                    placeholder="e.g. AMBATUR - III UNIT"
                                    disabled={editable}
                                  />
                                </div>
                              </div>

                              <div className="row mb-3">
                                <div className="col-md-6">
                                  <label>Port of Loading</label>
                                  <input
                                    {...register("portOfLoading")}
                                    type="text"
                                    className="form-control custom-placeholder"
                                    placeholder="e.g. MUMBAI PORT"
                                    disabled={editable}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>Port of Discharge</label>
                                  <input
                                    {...register("portOfDischarge")}
                                    type="text"
                                    className="form-control custom-placeholder"
                                    placeholder="e.g. CHENNAI PORT"
                                    disabled={editable}
                                  />
                                </div>
                              </div>

                              <div className="row mb-3">
                                <div className="col-md-6">
                                  <label>Type of Shipment</label>
                                  <input
                                    {...register("shipmentType")}
                                    type="text"
                                    className="form-control custom-placeholder"
                                    placeholder="e.g. FCL, LCL, AIR"
                                    disabled={editable}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>Remark</label>
                                  <input
                                    {...register("remark")}
                                    type="text"
                                    className="form-control custom-placeholder"
                                    placeholder="e.g. FCL, LCL, AIR"
                                    disabled={editable}
                                  />
                                </div>
                              </div>
                              {/* <div className='row '>
        <div className="col-md-6">
          <label >Terms of delivery</label>
          <input
            {...register("termdelivery")}
            type="text"
            className="form-control custom-placeholder"
            placeholder="e.g. FCL, LCL, AIR"
            disabled={editable}
          />
        </div>
      </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row   m-2"
                        style={{ border: "6px solid #E3F2FD", padding: "5px" }}
                      >
                        <div className="col-md-3">
                          <label>Gross Mass (Weight)</label>
                          <input
                            {...register("grossWeight")}
                            type="text"
                            className="form-control "
                            disabled={editable}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>Net Weight</label>
                          <input
                            {...register("netWeight", { required: false })}
                            type="text"
                            className="form-control "
                            disabled={editable}
                          />
                          {/* {additionalErrors.netWeight && <span className="text-danger">Required</span>} */}
                        </div>
                        <div className="col-md-3">
                          <label>Total Liters</label>
                          <input
                            {...register("totalLiters", { required: false })}
                            type="text"
                            className="form-control "
                            disabled={editable}
                          />
                          {/* {additionalErrors.totalLiters && <span className="text-danger">Required</span>} */}
                        </div>
                        <div className="col-md-3">
                          <label>COO</label>
                          <input
                            {...register("coo")}
                            type="text"
                            className="form-control "
                            disabled={editable}
                          />
                        </div>
                        <div className="col-md-4">
                          <label>Contact Name</label>
                          <input
                            {...register("contactName")}
                            type="text"
                            className="form-control "
                            disabled={editable}
                          />
                        </div>
                        <div className="col-md-4">
                          <label>Contact Phone</label>
                          <input
                            {...register("contactPhone")}
                            type="text"
                            className="form-control "
                            disabled={editable}
                          />
                        </div>
                        <div className="col-md-4">
                          <label>Contact Email</label>
                          <input
                            {...register("contactEmail")}
                            type="email"
                            className="form-control"
                            disabled={editable}
                          />
                        </div>
                      </div>

                      <div className="row mb-4">
                        <div className="col-12">
                          {editable === false && (
                            <div className="col-md p-0 mb-2 text-end">
                              <button
                                className="btn btn-primary  shadow-sm"
                                type="button"
                                onClick={addLine}
                                style={{
                                  border: "none",
                                }}
                              >
                                <i className="pi pi-plus me-2"></i>
                                Add New Invoice Line
                              </button>
                            </div>
                          )}

                          {/* <div className="table-responsive">
                <table className="table table-hover mb-0">
                <thead>
                  <tr style={{ 
                    color: "white"
                  }}>
                    <th style={{ width: "18%" }} className="border-0 fw-semibold py-3">
                      Product Name
                    </th>
                    <th className="border-0 fw-semibold py-3" style={{ width: "12%" }}>
                      Item Type
                    </th>
                    <th className="border-0 fw-semibold py-3" style={{ width: "5%" }}>
                      Quantity
                    </th>
                    <th className="border-0 fw-semibold py-3" style={{ width: "6%" }}>
                      Rate ({GlobalVariable.userDet.tenantConfig.currency})
                    </th>
                    <th className="border-0 fw-semibold py-3" style={{ width: "8%" }}>
                      Discount (%)
                    </th>
                    <th colSpan="3" className="border-0 fw-semibold py-3 text-center" style={{ width: "20%" }}>
                      <i className="pi pi-calculator me-2"></i>
                      Tax (%)
                    </th>
                    <th className="border-0 fw-semibold py-3" style={{ width: "7%" }}>
                      Net Amount ({GlobalVariable.userDet.tenantConfig.currency})
                    </th>
                    {editable === false && (
                      <th style={{ width: "3%" }} className="border-0 fw-semibold py-3 text-center">
                        <i className="pi pi-cog"></i>
                      </th>
                    )}
                  </tr>
                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    <th className="border-0"></th>
                    <th className="border-0"></th>
                    <th className="border-0"></th>
                    <th className="border-0"></th>
                    <th className="border-0"></th>
                    <th className="border-0 fw-semibold text-center py-2">
                      {countryTaxDetails?.localTaxName}
                    </th>
                    <th className="border-0 fw-semibold text-center py-2">
                      {countryTaxDetails?.centralTaxName}
                    </th>
                    <th className="border-0 fw-semibold text-center py-2">
                      {countryTaxDetails?.interTaxName}
                    </th>
                    <th className="border-0"></th>
                    {editable === false && <th className="border-0"></th>}
                  </tr>
                </thead>
                <tbody>
                  {invoiceLines.map((line, index) => (
                    <tr key={index} className="border-bottom">
                      <td className="py-3">
                        <Dropdown
                          value={line.productname}
                          onChange={(e) => {
                            if (e.value?.code === "add-new") {
                              handleAddClick();
                            } else {
                              handleSelectProduct(e.value, index);
                            }
                          }}
                          options={extendedProductDrop}
                          disabled
                          optionLabel="name"
                          placeholder="Choose to select"
                          className="form-control border-0 shadow-sm rounded-3"
                          panelClassName="custAddBtn"
                          itemTemplate={itemTemplate}
                        />
                        <NewItem
                          isOpen={isModalOpen}
                          onClose={handleModalClose}
                          onSuccess={handleItemAddSuccess}
                        />
                      </td>
                      <td className="py-3">
                        {isType && (
                          <div className="row">
                            <div className="col-md">
                              <input
                                type="text"
                                name="producttype"
                                className={`form-control text-center border-0 shadow-sm rounded-3 ${
                                  line.producttype === "goods"
                                    ? "bg-success-subtle text-success"
                                    : "bg-info-subtle text-info"
                                }`}
                                value={line.producttype}
                                disabled
                              />
                            </div>
                            <div className={`col-md d-flex justify-content-center align-items-center small ${
                              line.producttype === "goods"
                                ? "text-success"
                                : "text-info"
                            }`}>
                              <label className="mb-0 fw-semibold">
                                {line.producttype === "goods" ? "HSN:" : "SAC:"}
                              </label>
                              <span className="ms-1">{line.productname?.saCorHSNCode}</span>
                            </div>
                          </div>
                        )}
                      </td>
                      <td className="py-3">
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            name="quantity"
                            className="form-control text-end border-0 shadow-sm rounded-3"
                            disabled={!line.productname ? true : false || editable}
                            value={line.quantity}
                            onInput={(e) => {
                              handleInputChangeQuantity(e, index, line.productname);
                            }}
                          />
                          <span className="ms-2 small text-muted fw-semibold">
                            {line?.productname.unit}
                          </span>
                        </div>
                        {line.quantityError && (
                          <div className="text-danger mt-1 small">
                            <i className="pi pi-exclamation-triangle me-1"></i>
                            {line.quantityError}
                          </div>
                        )}
                      </td>
                      <td className="py-3">
                        <input
                          type="number"
                          name="rate"
                          className="form-control text-end border-0 shadow-sm rounded-3 bg-light"
                          disabled
                          value={line.rate}
                        />
                      </td>
                      <td className="py-3">
                        <input
                          type="number"
                          name="discount"
                          className="form-control text-end border-0 shadow-sm rounded-3"
                          value={line.discount}
                          onInput={(e) => {
                            handleInputChangeDiscount(e, index);
                          }}
                          disabled={editable}
                        />
                      </td>
                      <td className="py-3">
                        <input
                          type="number"
                          name="statetax"
                          className="form-control text-end border-0 shadow-sm rounded-3 bg-light"
                          disabled
                          title="To adjust the tax percentage, please access the Inventory section"
                          value={line.statetax}
                          onInput={(e) => handleInputChangeStateTax(e, index)}
                        />
                      </td>
                      <td className="py-3">
                        <input
                          type="number"
                          name="centraltax"
                          className="form-control text-end border-0 shadow-sm rounded-3 bg-light"
                          disabled
                          title="To adjust the tax percentage, please access the Inventory section"
                          value={line.centraltax}
                          onInput={(e) => handleInputChangeCentralTax(e, index)}
                        />
                      </td>
                      <td className="py-3">
                        <input
                          type="number"
                          name="intertax"
                          className="form-control text-end border-0 shadow-sm rounded-3 bg-light"
                          disabled
                          title="To adjust the tax percentage, please access the Inventory section"
                          value={line.intertax}
                          onInput={(e) => handleInputChangeInterTax(e, index)}
                        />
                      </td>
                      <td className="py-3">
                        <input
                          type="number"
                          name="netamount"
                          className="form-control text-end border-0 shadow-sm rounded-3 bg-light fw-semibold"
                          value={line.netamount}
                          disabled
                        />
                      </td>
                      {editable === false && (
                        <td className="text-center py-3">
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm rounded-circle"
                            onClick={() => deleteLineItem(line, index)}
                            style={{ width: "32px", height: "32px" }}
                          >
                            <i className="pi pi-trash" style={{ fontSize: "12px" }}></i>
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              {manualErr && (
                <div className="alert alert-danger m-3 rounded-3">
                  <i className="pi pi-exclamation-triangle me-2"></i>
                  {manualErr}
                </div>
              )}
              </div> */}
                          <NewItem
                            isOpen={isModalOpen}
                            onClose={handleModalClose}
                            onSuccess={handleItemAddSuccess}
                          />
                          <div className="scrollable-table">
  <table className="table table-bordered custom-table">
                              <thead>
                                <tr>
                                  <th
                                    className="text-center fw-semibold"
                                    style={{ width: "5%" }}
                                  >
                                    S.No
                                  </th>
                                  <th
                                    className="text-center fw-semibold"
                                    style={{ width: "8%" }}
                                  >
                                    Product Code
                                  </th>
                                  <th className="text-center fw-semibold">
                                    Product Name
                                  </th>
                                  <th
                                    className="text-center fw-semibold"
                                    style={{ width: "9%" }}
                                  >
                                    Quantity
                                  </th>
                                  {/* <th className="text-center fw-semibold" style={{ width: '6%' }}>No. of Box</th> */}
                                  <th
                                    className="text-center fw-semibold"
                                    style={{ width: "7%" }}
                                  >
                                    Discount (%)
                                  </th>
                                  <th className="text-center fw-semibold">
                                    Tax %
                                  </th>
                                  <th
                                    className="text-center fw-semibold"
                                    style={{ width: "10%" }}
                                  >
                                    Per Item Rate
                                    <br />
                                    <small>(With Tax & Discount)</small>
                                  </th>
                                  <th className="text-center fw-semibold">
                                    Net Amount
                                  </th>
                                  <th className="text-center fw-semibold">
                                    <i className="pi pi-cog"></i>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {invoiceLines.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      className="text-center text-muted py-3"
                                    >
                                      <i className="pi pi-info-circle me-2 text-primary"></i>
                                      No line items added yet. Click{" "}
                                      <strong>"Add New Invoice Line"</strong> to
                                      begin.
                                    </td>
                                  </tr>
                                ) : (
                                  invoiceLines.map((line, index) => (
                                    <tr key={line.id}>
                                      <td className="text-center">{index + 1}</td>
                                      <td className="text-center">
                                        {line.code ||
                                          line.productname?.saCorHSNCode ||
                                          "—"}
                                      </td>
                                      <td className="text-center">
                                        {line.productname?.name || "—"}
                                      </td>
                                      <td className="text-center">
                                        {line.quantity}
                                        <br />
                                        {line.isesecunit && (
                                          <small className="text-muted">
                                            ({line.btlperbox || 0}{" "}
                                            {line.productname?.secUnit || ""})
                                          </small>
                                        )}
                                      </td>
                                      <td className="text-center">
                                        {line.discount || 0}
                                      </td>
                                      <td className="text-center">
                                        {Number(line.statetax || 0) +
                                          Number(line.centraltax || 0) +
                                          Number(line.intertax || 0) +
                                          "%"}
                                      </td>
                                      <td className="text-end">
                                        {
                                          GlobalVariable.userDet.tenantConfig
                                            .currency
                                        }{" "}
                                        {(
                                          Number(line.netamount) /
                                          Number(line.quantity || 1)
                                        ).toFixed(2)}
                                        <br />
                                        {line.isesecunit && (
                                          <small className="text-muted">
                                            (
                                            {
                                              GlobalVariable.userDet.tenantConfig
                                                .currency
                                            }{" "}
                                            {(
                                              Number(line.netamount) /
                                              Number(line.btlperbox || 0)
                                            ).toFixed(2)}{" "}
                                            per {line.productname?.secUnit || ""})
                                          </small>
                                        )}
                                      </td>
                                      <td className="text-end">
                                        {
                                          GlobalVariable.userDet.tenantConfig
                                            .currency
                                        }{" "}
                                        {Number(line.netamount).toFixed(2)}
                                      </td>
                                      <td className="text-center">
                                        <button
                                          type="button"
                                          className="btn btn-outline-success btn-sm rounded-circle mx-1"
                                          onClick={() => handleEdit(line, index)}
                                          disabled={editable}
                                          style={{
                                            width: "32px",
                                            height: "32px",
                                          }}
                                        >
                                          <i
                                            className="pi pi-pencil"
                                            style={{ fontSize: "12px" }}
                                          ></i>
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger btn-sm rounded-circle"
                                          onClick={() =>
                                            deleteLineItem(line, index)
                                          }
                                          disabled={editable}
                                          style={{
                                            width: "32px",
                                            height: "32px",
                                          }}
                                        >
                                          <i
                                            className="pi pi-trash"
                                            style={{ fontSize: "12px" }}
                                          ></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-4 d-flex justify-content-between align-items-center">
                        <div className="col-md-12">
                          <div className="row mx-auto my-4 justify-content-end">
                            {/* {editable === false && (
                <div className="col-md-4 p-0">
                  <button
                    className="btn btn-primary rounded-pill shadow-sm"
                    type="button"
                    onClick={addLine}
                    style={{ 
                      border: "none"
                    }}
                  >
                    <i className="pi pi-plus me-2"></i>
                    Add New Invoice Line
                  </button>
                </div>
              )} */}

                            <div className="col-md-4 p-0">
                              <div
                                className="card border-0 shadow-sm rounded-3"
                                style={{ backgroundColor: "#f8f9fa" }}
                              >
                                <div
                                  className="card-body p-4"
                                  style={{ backgroundColor: "#f5fdff" }}
                                >
                                  <h5
                                    className="card-title fw-bold mb-3"
                                    style={{ color: "#3E9D71" }}
                                  >
                                    Invoice Summary
                                  </h5>

                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">
                                      Sub Total
                                    </span>
                                    <span className="fw-semibold">
                                      {
                                        GlobalVariable.userDet.tenantConfig
                                          .currency
                                      }{" "}
                                      {subTotal}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">Discount</span>
                                    <span
                                      className={
                                        discountedAmount !== "0.00"
                                          ? "text-danger fw-semibold"
                                          : "fw-semibold"
                                      }
                                    >
                                      {discountedAmount !== "0.00" ? "- " : ""}
                                      {
                                        GlobalVariable.userDet.tenantConfig
                                          .currency
                                      }{" "}
                                      {discountedAmount}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">
                                      Tax (SGST)
                                    </span>
                                    <span className="fw-semibold">
                                      {
                                        GlobalVariable.userDet.tenantConfig
                                          .currency
                                      }{" "}
                                      {sgstTaxAmount}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">
                                      Tax (CGST)
                                    </span>
                                    <span className="fw-semibold">
                                      {
                                        GlobalVariable.userDet.tenantConfig
                                          .currency
                                      }{" "}
                                      {cgstTaxAmount}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">
                                      Tax (IGST)
                                    </span>
                                    <span className="fw-semibold">
                                      {
                                        GlobalVariable.userDet.tenantConfig
                                          .currency
                                      }{" "}
                                      {igstTaxAmount}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">
                                      Shipping Charges
                                    </span>
                                    <div className="d-flex align-items-center">
                                      <span className="me-2">
                                        {
                                          GlobalVariable.userDet.tenantConfig
                                            .currency
                                        }
                                      </span>
                                      <input
                                        value={shipCharge}
                                        type="number"
                                        name="shippngcharge"
                                        className="form-control form-control-sm text-end border-0 shadow-sm rounded-3"
                                        style={{ width: "70px" }}
                                        disabled={editable}
                                        onInput={(e) => {
                                          getShippingCharge(e);
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {hasDecimal ? (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <span className="text-muted">
                                        Round off
                                      </span>
                                      <select
                                        className="form-select form-select-sm"
                                        style={{ width: "100px" }}
                                        value={selectedRound}
                                        onChange={(e) =>
                                          setSelectedRound(
                                            parseFloat(e.target.value)
                                          )
                                        }
                                      >
                                        {roundOptions.map((opt, index) => (
                                          <option
                                            key={index}
                                            value={opt.value}
                                            disabled={editable}
                                          >
                                            {
                                              GlobalVariable.userDet
                                                .tenantConfig.currency
                                            }{" "}
                                            {opt.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  ) : (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <span className="text-muted">
                                        Round off
                                      </span>
                                      <span className="fw-semibold">
                                        {
                                          GlobalVariable.userDet.tenantConfig
                                            .currency
                                        }{" "}
                                        0.00
                                      </span>
                                    </div>
                                  )}

                                  <hr className="my-3" />

                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <span className="fw-bold text-dark fs-5">
                                      Total
                                    </span>
                                    <span className="fw-bold text-primary fs-5">
                                      {
                                        GlobalVariable.userDet.tenantConfig
                                          .currency
                                      }{" "}
                                      {finalTotal}
                                    </span>
                                  </div>

                                  {editable === true && (
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span className="fw-bold text-warning">
                                        Balance Due
                                      </span>
                                      <span className="fw-bold text-warning fs-5">
                                        {
                                          GlobalVariable.userDet.tenantConfig
                                            .currency
                                        }{" "}
                                        {editModeData.balancePayment?.toFixed(
                                          2
                                        )}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {editModeData.balancePayment?.toFixed(2) ===
                            "0.00" && (
                            <div className="row mx-auto mt-3 p-0">
                              <div className="col-md-8 p-0"></div>
                              <div className="col-md-4 p-0">
                                <div className="alert alert-success rounded-3 shadow-sm">
                                  <i className="pi pi-check-circle me-2"></i>
                                  <strong>Success!</strong> No Due! Full amount
                                  paid
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="d-flex mt-4 justify-content-end gap-3 p-0">
                            {editable === false ? (
                              <>
                                <Button
                                  className="btn btn-danger my-3"
                                  type="button"
                                  onClick={invoiceCancel}
                                  label="Cancel"
                                  style={{ border: "2px solid" }}
                                />
                                <Button
                                  className="btn btn-primary my-3"
                                  onClick={handleSubmit((e) =>
                                    submitFinalInvoice(e, "DRAFT")
                                  )}
                                  type="button"
                                  label="Save Draft"
                                  style={{ border: "2px solid" }}
                                  disabled={invoiceLines.length === 0}
                                />
                                {!isUpdate ? (
                                  <Button
                                    type="button"
                                    className="btn btn-primary my-3"
                                    label="Save & Submit"
                                    onClick={handleSubmit(
                                      (e) => submitFinalInvoice(e, "OPEN"),
                                      onInvalid
                                    )}
                                    style={{ border: "none" }}
                                    disabled={invoiceLines.length === 0}
                                  />
                                ) : (
                                  <Button
                                    type="button"
                                    className="btn btn-primary my-3"
                                    label="Update"
                                    onClick={handleSubmit((e) =>
                                      submitFinalInvoice(e, "OPEN")
                                    )}
                                    style={{ border: "none" }}
                                    disabled={invoiceLines.length === 0}
                                  />
                                )}
                              </>
                            ) : (
                              <Button
                                className="btn btn-danger my-3"
                                type="button"
                                onClick={backToAllInvoice}
                                label="Back"
                                style={{ border: "2px solid" }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {isProcess && (
                  <ProgressSpinner
                    style={{
                      width: "50px",
                      height: "50px",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1000,
                    }}
                    strokeWidth="3"
                    fill="var(--surface-ground)"
                    animationDuration=".5s"
                  />
                )}
              </div>
            </div>
            <ConfirmPopup />
          </form>
        )}
        <Dialog
          header="Add New Invoice Line"
          visible={displaynewItem}
          onHide={() => {
            mReset();
            setSelectedItem(null);
            setdisplaynewItem(false);
            setIsDisabled(false);
            setIsScroll(false)
            document.body.style.overflow = "auto";
          }}
          breakpoints={{ "960px": "75vw" }}
          style={{ width: "40vw" }}
          footer={renderFooter("displaynewItem")}
          className="custom-dialog"
          blockScroll={isScroll}
        >
          <form onSubmit={modalHandleSubmit(modelOnSubmit)}>
            <div className="container-fluid">
              <div className="row align-items-center my-3">
                <label
                  className="col-4 mt-3 fw-bold "
                  style={{ color: "#3E9D71" }}
                >
                  Type
                </label>
                <div className="col-8 d-flex gap-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      {...modalRegister("type")}
                      value="goods"
                      id="goods"
                      onChange={() => handleTypeChange("goods")}
                    />

                    <label
                      className="form-check-label fw-medium d-flex align-items-center ms-1"
                      htmlFor="goods"
                    >
                      <i className="pi pi-box me-1"></i>Goods
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      {...modalRegister("type")}
                      value="service"
                      id="service"
                      onChange={() => handleTypeChange("service")}
                    />

                    <label
                      className="form-check-label fw-medium d-flex align-items-center ms-1"
                      htmlFor="service"
                    >
                      <i className="pi pi-cog me-1"></i>Service
                    </label>
                  </div>
                </div>
              </div>

              {modalWatch("type") && (
                <div className="row align-items-center mb-3">
                  <label
                    className="col-4 mt-3 fw-bold "
                    style={{ color: "#3E9D71" }}
                  >
                    Product
                  </label>
                  <div className="col-6">
                    <Controller
                      name="name"
                      control={modalControl}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.value);
                            setSelectedItem(e.value);
                            setIsDisabled(true);
                            modelReset(e);
                          }}
                          options={
                            Array.isArray(goodsOrServiceItems)
                              ? goodsOrServiceItems
                              : []
                          }
                          filter
                          optionLabel="name"
                          placeholder="Select a product..."
                          className="w-100"
                          showClear
                          // appendTo="self"
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-2 ms-auto ">
                    <Button
                      className="btn btn-primary "
                      onClick={handleAddClick}
                      type="button"
                      label="Add New"
                    />
                  </div>
                </div>
              )}

              {modalWatch("type") && selectedItem && (
                <div className="card shadow-sm border-0 p-3">
                  <div className="row mb-3">
                   <div className="col-4 ">
  <label className=" required">Quantity</label>
  <input
    type="number"
    className={`form-control custom-placeholder form-control-sm ${
      modalErrors.quantity ? "is-invalid" : ""
    }`}
    placeholder="Enter quantity"
    {...modalRegister("quantity", {
      required: "Quantity is required",
      min: {
        value: 1,
        message: "Quantity must be at least 1",
      },
      validate: (value) =>
        value <= (modalWatch("name")?.stocks ?? 0) ||
        `Only ${modalWatch("name")?.stocks ?? 0} in stock available`,
    })}
  />
  {modalErrors.quantity && (
    <small className="text-danger">
      {modalErrors.quantity.message}
    </small>
  )}
</div>

                    <div className="col-4 ">
                      <label className="">
                        {secUnitLabel || "Bottle"} per {unitLabel || "Box"}
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={perCount}
                        readOnly
                        disabled
                        {...modalRegister("percount")}
                      />
                    </div>

                    <div className="col-4 ">
                      <label className="">
                        Total {secUnitLabel || "Bottle"}
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={totalBottles}
                        readOnly
                        disabled
                        {...modalRegister("per")}
                      />
                    </div>

                    <div className="col-4 mt-3">
                      <label className="">Discount (%)</label>
                      <input
                        type="number"
                        className={`form-control custom-placeholder  form-control-sm ${
                          modalErrors.discount ? "is-invalid" : ""
                        }`}
                        placeholder="Enter discount"
                        {...modalRegister("discount", {
                          required: false,
                          min: { value: 0, message: "Minimum value is 0" },
                          max: { value: 100, message: "Cannot exceed 100%" },
                        })}
                      />
                      {modalErrors.discount && (
                        <small className="text-danger">
                          {modalErrors.discount.message}
                        </small>
                      )}
                    </div>
                    <div className="col-4 mt-3 ">
                      <label className="">MFG Start Date</label>
                      <input
                        type="date"
                        className={`form-control custom-placeholder  form-control-sm ${
                          modalErrors.mfgsdate ? "is-invalid" : ""
                        }`}
                        {...modalRegister("mfgsdate", {
                          required: false,
                        })}
                      />
                      {modalErrors.mfgsdate && (
                        <small className="text-danger">
                          {modalErrors.mfgsdate.message}
                        </small>
                      )}
                    </div>
                    <div className="col-4 mt-3 ">
                      <label className="">MFG End Date</label>
                      <input
                        type="date"
                        className={`form-control custom-placeholder  form-control-sm ${
                          modalErrors.mgfedate ? "is-invalid" : ""
                        }`}
                        {...modalRegister("mgfedate", {
                          required: false,
                        })}
                      />
                      {modalErrors.mgfedate && (
                        <small className="text-danger">
                          {modalErrors.mgfedate.message}
                        </small>
                      )}
                    </div>

                    <div className="col-4 mt-3 ">
                      <label className="">Batch No.</label>
                      <input
                        type="text"
                        className={`form-control custom-placeholder  form-control-sm ${
                          modalErrors.batchno ? "is-invalid" : ""
                        }`}
                        placeholder="Enter batch no."
                        {...modalRegister("batchno", {
                          required: false,
                        })}
                      />
                      {modalErrors.batchno && (
                        <small className="text-danger">
                          {modalErrors.batchno.message}
                        </small>
                      )}
                    </div>

                    <div className="col-8 mt-3">
                      <label className="">Description</label>
                      <textarea
                        rows={2}
                        className="form-control custom-placeholder  form-control-sm"
                        placeholder="Enter product description"
                        {...modalRegister("description")}
                      />
                      {modalErrors.description && (
                        <small className="text-danger">
                          {modalErrors.description.message}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="card-header bg-light border-0">
                    <h6 className="mb-0 fw-bold text-dark">
                      <i
                        className="pi pi-info-circle me-2 "
                        style={{ color: "#3E9D71" }}
                      ></i>
                      Product Details
                    </h6>
                  </div>
                  <div className="card-body p-0">
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label className="">Product Code</label>
                        <input
                          className="form-control form-control-sm"
                          {...modalRegister("code")}
                          placeholder="Enter HSN/SAC code"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="">Stock</label>
                        <input
                          className="form-control form-control-sm"
                          defaultValue={itemData.stocks}
                          onChange={(e) =>
                            setItemData({ ...itemData, stocks: e.target.value })
                          }
                          {...modalRegister("stocks")}
                          disabled={isDisabled}
                          placeholder="Enter stock quantity"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="">Selling Price</label>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text  text-black">
                            {GV.userDet.tenantConfig.currency}
                          </span>
                          <input
                            type="number"
                            className="form-control"
                            {...modalRegister("sellingprice", {
                              disabled:
                                modalWatch("salescheck") === false ||
                                isDisabled,
                            })}
                            placeholder="0.00"
                          />
                        </div>
                      </div>

                      <div className="col-12 mt-3">
                        <label className="">Tax Preference</label>
                        <input
                          className="form-control form-control-sm"
                          {...modalRegister("taxpreference")}
                          disabled={isDisabled}
                          placeholder="Enter tax preference"
                        />
                      </div>

                      {modalWatch("taxpreference") === "Taxable" && (
                        <div className="col-12">
                          <div className="bg-light rounded p-3 mt-2">
                            <h6 className="fw-semibold text-success">
                              Tax Details
                            </h6>
                            <div className="row g-3">
                              <div className="col-md-4">
                                <label className="form-label fw-medium">
                                  CGST (%)
                                </label>
                                <input
                                  className="form-control form-control-sm"
                                  {...modalRegister("cgst")}
                                  disabled={isDisabled}
                                  placeholder="0.00"
                                />
                              </div>
                              <div className="col-md-4">
                                <label className="form-label fw-medium">
                                  SGST (%)
                                </label>
                                <input
                                  className="form-control form-control-sm"
                                  {...modalRegister("sgst")}
                                  disabled={isDisabled}
                                  placeholder="0.00"
                                />
                              </div>
                              <div className="col-md-4">
                                <label className="form-label fw-medium">
                                  IGST (%)
                                </label>
                                <input
                                  className="form-control form-control-sm"
                                  {...modalRegister("igst")}
                                  disabled={isDisabled}
                                  placeholder="0.00"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {isProcess && (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <ProgressSpinner
                    style={{
                      width: "60px",
                      height: "60px",
                    }}
                    strokeWidth="3"
                    fill="var(--surface-ground)"
                    animationDuration=".8s"
                  />
                  <div className="text-center mt-2">
                    <small className="text-muted">Processing...</small>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Dialog>
        <Dialog
          header="Additional Info"
          visible={showInfoForm}
          onHide={() => setShowInfoForm(false)}
          style={{ width: "30vw" }}
        >
          <form
            onSubmit={additionalHandleSubmit(onAdditionalInfoSubmit)}
            className="my-3"
          >
            <div className="row mb-2 align-items-center">
              <div className="col-5">
                <label className="fw-semibold">Gross Mass (Weight):</label>
              </div>
              <div className="col-7">
                <input
                  {...additionalRegister("grossWeight")}
                  type="text"
                  className="form-control form-control-sm"
                />
              </div>
            </div>

            <div className="row mb-2 align-items-center">
              <div className="col-5">
                <label className="fw-semibold">
                  Net Weight <span className="text-danger">*</span>:
                </label>
              </div>
              <div className="col-7">
                <input
                  {...additionalRegister("netWeight", { required: true })}
                  type="text"
                  className="form-control form-control-sm"
                />
                {additionalErrors.netWeight && (
                  <span className="text-danger">Required</span>
                )}
              </div>
            </div>

            <div className="row mb-2 align-items-center">
              <div className="col-5">
                <label className="fw-semibold">
                  Total Liters <span className="text-danger">*</span>:
                </label>
              </div>
              <div className="col-7">
                <input
                  {...additionalRegister("totalLiters", { required: true })}
                  type="text"
                  className="form-control form-control-sm"
                />
                {additionalErrors.totalLiters && (
                  <span className="text-danger">Required</span>
                )}
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              <div className="col-5">
                <label className="fw-semibold">COO</label>
              </div>
              <div className="col-7">
                <input
                  {...additionalRegister("coo")}
                  type="text"
                  className="form-control form-control-sm"
                />
              </div>
            </div>

            <h6 className="fw-bold mt-3">Contact Person Details </h6>

            <div className="row mb-2 align-items-center">
              <div className="col-5">
                <label className="fw-semibold">Contact Name:</label>
              </div>
              <div className="col-7">
                <input
                  {...additionalRegister("contactName")}
                  type="text"
                  className="form-control form-control-sm"
                />
              </div>
            </div>

            <div className="row mb-2 align-items-center">
              <div className="col-5">
                <label className="fw-semibold">Contact Phone</label>
              </div>
              <div className="col-7">
                <input
                  {...additionalRegister("contactPhone")}
                  type="text"
                  className="form-control form-control-sm"
                />
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              <div className="col-5">
                <label className="fw-semibold">Contact Email</label>
              </div>
              <div className="col-7">
                <input
                  {...additionalRegister("contactEmail")}
                  type="email"
                  className="form-control form-control-sm"
                />
              </div>
            </div>

            <div className="d-flex justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-danger me-2"
                onClick={() => setShowInfoForm(false)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </Dialog>
      </BlockUI>
    </div>
  );
};

export default Invoice;
